// Algerian Communes grouped by Wilaya ID
// Source: https://github.com/othmanus/algeria-cities
// IDs follow the WWCC convention: wilayaId * 100 + index

export interface Commune {
  id: number;
  name: string;
  nameAr: string;
}

export const COMMUNES: Record<number, Commune[]> = {
  1: [
    { id: 101, name: 'Adrar', nameAr: 'أدرار' },
    { id: 102, name: 'Akabli', nameAr: 'اقبلي' },
    { id: 103, name: 'Aoulef', nameAr: 'أولف' },
    { id: 104, name: 'Bouda', nameAr: 'بودة' },
    { id: 105, name: 'Fenoughil', nameAr: 'فنوغيل' },
    { id: 106, name: 'In Zghmir', nameAr: 'إن زغمير' },
    { id: 107, name: 'Ouled Ahmed Timmi', nameAr: 'أولاد أحمد تيمي' },
    { id: 108, name: 'Reggane', nameAr: 'رقان' },
    { id: 109, name: 'Sali', nameAr: 'سالي' },
    { id: 110, name: 'Sebaa', nameAr: 'السبع' },
    { id: 111, name: 'Tamantit', nameAr: 'تامنطيط' },
    { id: 112, name: 'Tamest', nameAr: 'تامست' },
    { id: 113, name: 'Timekten', nameAr: 'تيمقتن' },
    { id: 114, name: 'Tit', nameAr: 'تيت' },
    { id: 115, name: 'Tsabit', nameAr: 'تسابيت' },
    { id: 116, name: 'Zaouiet Kounta', nameAr: 'زاوية كنتة' },
  ],
  2: [
    { id: 201, name: 'Abou El Hassane', nameAr: 'أبو الحسن' },
    { id: 202, name: 'Ain Merane', nameAr: 'عين مران' },
    { id: 203, name: 'Benairia', nameAr: 'بنايرية' },
    { id: 204, name: 'Beni  Bouattab', nameAr: 'بني بوعتاب' },
    { id: 205, name: 'Beni Haoua', nameAr: 'بني حواء' },
    { id: 206, name: 'Beni Rached', nameAr: 'بني راشد' },
    { id: 207, name: 'Boukadir', nameAr: 'بوقادير' },
    { id: 208, name: 'Bouzeghaia', nameAr: 'بوزغاية' },
    { id: 209, name: 'Breira', nameAr: 'بريرة' },
    { id: 210, name: 'Chettia', nameAr: 'الشطية' },
    { id: 211, name: 'Chlef', nameAr: 'الشلف' },
    { id: 212, name: 'Dahra', nameAr: 'الظهرة' },
    { id: 213, name: 'El Hadjadj', nameAr: 'الحجاج' },
    { id: 214, name: 'El Karimia', nameAr: 'الكريمية' },
    { id: 215, name: 'El Marsa', nameAr: 'المرسى' },
    { id: 216, name: 'Harchoun', nameAr: 'حرشون' },
    { id: 217, name: 'Herenfa', nameAr: 'الهرانفة' },
    { id: 218, name: 'Labiod Medjadja', nameAr: 'الأبيض مجاجة' },
    { id: 219, name: 'Moussadek', nameAr: 'مصدق' },
    { id: 220, name: 'Oued Fodda', nameAr: 'وادي الفضة' },
    { id: 221, name: 'Oued Goussine', nameAr: 'وادي قوسين' },
    { id: 222, name: 'Oued Sly', nameAr: 'وادي سلي' },
    { id: 223, name: 'Ouled Abbes', nameAr: 'أولاد عباس' },
    { id: 224, name: 'Ouled Ben Abdelkader', nameAr: 'أولاد بن عبد القادر' },
    { id: 225, name: 'Ouled Fares', nameAr: 'أولاد فارس' },
    { id: 226, name: 'Oum Drou', nameAr: 'أم الدروع' },
    { id: 227, name: 'Sendjas', nameAr: 'سنجاس' },
    { id: 228, name: 'Sidi Abderrahmane', nameAr: 'سيدي عبد الرحمن' },
    { id: 229, name: 'Sidi Akkacha', nameAr: 'سيدي عكاشة' },
    { id: 230, name: 'Sobha', nameAr: 'الصبحة' },
    { id: 231, name: 'Tadjena', nameAr: 'تاجنة' },
    { id: 232, name: 'Talassa', nameAr: 'تلعصة' },
    { id: 233, name: 'Taougrit', nameAr: 'تاوقريت' },
    { id: 234, name: 'Tenes', nameAr: 'تنس' },
    { id: 235, name: 'Zeboudja', nameAr: 'الزبوجة' },
  ],
  3: [
    { id: 301, name: 'Aflou', nameAr: 'أفلو' },
    { id: 302, name: 'Ain Madhi', nameAr: 'عين ماضي' },
    { id: 303, name: 'Ain Sidi Ali', nameAr: 'عين سيدي علي' },
    { id: 304, name: 'Benacer Benchohra', nameAr: 'بن ناصر بن شهرة' },
    { id: 305, name: 'Brida', nameAr: 'بريدة' },
    { id: 306, name: 'El Assafia', nameAr: 'العسافية' },
    { id: 307, name: 'El Beidha', nameAr: 'البيضاء' },
    { id: 308, name: 'El Ghicha', nameAr: 'الغيشة' },
    { id: 309, name: 'El Haouaita', nameAr: 'الحويطة' },
    { id: 310, name: 'Gueltat Sidi Saad', nameAr: 'قلتة سيدي سعد' },
    { id: 311, name: 'Hadj Mechri', nameAr: 'الحاج مشري' },
    { id: 312, name: 'Hassi Delaa', nameAr: 'حاسي الدلاعة' },
    { id: 313, name: 'Hassi R\'mel', nameAr: 'حاسي الرمل' },
    { id: 314, name: 'Kheneg', nameAr: 'الخنق' },
    { id: 315, name: 'Ksar El Hirane', nameAr: 'قصر الحيران' },
    { id: 316, name: 'Laghouat', nameAr: 'الأغواط' },
    { id: 317, name: 'Oued M\'zi', nameAr: 'وادي مزي' },
    { id: 318, name: 'Oued Morra', nameAr: 'وادي مرة' },
    { id: 319, name: 'Sebgag', nameAr: 'سبقاق' },
    { id: 320, name: 'Sidi Bouzid', nameAr: 'سيدي بوزيد' },
    { id: 321, name: 'Sidi Makhlouf', nameAr: 'سيدي مخلوف' },
    { id: 322, name: 'Tadjemout', nameAr: 'تاجموت' },
    { id: 323, name: 'Tadjrouna', nameAr: 'تاجرونة' },
    { id: 324, name: 'Taouiala', nameAr: 'تاويالة' },
  ],
  4: [
    { id: 401, name: 'Ain Babouche', nameAr: 'عين ببوش' },
    { id: 402, name: 'Ain Beida', nameAr: 'عين البيضاء' },
    { id: 403, name: 'Ain Diss', nameAr: 'عين الديس' },
    { id: 404, name: 'Ain Fekroun', nameAr: 'عين فكرون' },
    { id: 405, name: 'Ain Kercha', nameAr: 'عين كرشة' },
    { id: 406, name: 'Ain M\'lila', nameAr: 'عين مليلة' },
    { id: 407, name: 'Ain Zitoun', nameAr: 'عين الزيتون' },
    { id: 408, name: 'Behir Chergui', nameAr: 'بحير الشرقي' },
    { id: 409, name: 'Berriche', nameAr: 'بريش' },
    { id: 410, name: 'Bir Chouhada', nameAr: 'بئر الشهداء' },
    { id: 411, name: 'Dhalaa', nameAr: 'الضلعة' },
    { id: 412, name: 'El Amiria', nameAr: 'العامرية' },
    { id: 413, name: 'El Belala', nameAr: 'البلالة' },
    { id: 414, name: 'El Djazia', nameAr: 'الجازية' },
    { id: 415, name: 'El Fedjoudj Boughrara Sa', nameAr: 'الفجوج بوغرارة سعودي' },
    { id: 416, name: 'El Harmilia', nameAr: 'الحرملية' },
    { id: 417, name: 'Fkirina', nameAr: 'فكيرينة' },
    { id: 418, name: 'Hanchir Toumghani', nameAr: 'هنشير تومغني' },
    { id: 419, name: 'Ksar Sbahi', nameAr: 'قصر الصباحي' },
    { id: 420, name: 'Meskiana', nameAr: 'مسكيانة' },
    { id: 421, name: 'Oued Nini', nameAr: 'وادي نيني' },
    { id: 422, name: 'Ouled Gacem', nameAr: 'أولاد قاسم' },
    { id: 423, name: 'Ouled Hamla', nameAr: 'أولاد حملة' },
    { id: 424, name: 'Ouled Zouai', nameAr: 'أولاد زواي' },
    { id: 425, name: 'Oum El Bouaghi', nameAr: 'أم البواقي' },
    { id: 426, name: 'Rahia', nameAr: 'الرحية' },
    { id: 427, name: 'Sigus', nameAr: 'سيقوس' },
    { id: 428, name: 'Souk Naamane', nameAr: 'سوق نعمان' },
    { id: 429, name: 'Zorg', nameAr: 'الزرق' },
  ],
  5: [
    { id: 501, name: 'Ain Djasser', nameAr: 'عين جاسر' },
    { id: 502, name: 'Ain Touta', nameAr: 'عين التوتة' },
    { id: 503, name: 'Ain Yagout', nameAr: 'عين ياقوت' },
    { id: 504, name: 'Arris', nameAr: 'أريس' },
    { id: 505, name: 'Azil Abedelkader', nameAr: 'عزيل عبد القادر' },
    { id: 506, name: 'Barika', nameAr: 'بريكة' },
    { id: 507, name: 'Batna', nameAr: 'باتنة' },
    { id: 508, name: 'Beni Foudhala El Hakania', nameAr: 'بني فضالة الحقانية' },
    { id: 509, name: 'Bitam', nameAr: 'بيطام' },
    { id: 510, name: 'Boulhilat', nameAr: 'بولهيلات' },
    { id: 511, name: 'Boumagueur', nameAr: 'بومقر' },
    { id: 512, name: 'Boumia', nameAr: 'بومية' },
    { id: 513, name: 'Bouzina', nameAr: 'بوزينة' },
    { id: 514, name: 'Chemora', nameAr: 'الشمرة' },
    { id: 515, name: 'Chir', nameAr: 'شير' },
    { id: 516, name: 'Djerma', nameAr: 'جرمة' },
    { id: 517, name: 'Djezzar', nameAr: 'الجزار' },
    { id: 518, name: 'El Hassi', nameAr: 'الحاسي' },
    { id: 519, name: 'El Madher', nameAr: 'المعذر' },
    { id: 520, name: 'Fesdis', nameAr: 'فسديس' },
    { id: 521, name: 'Foum Toub', nameAr: 'فم الطوب' },
    { id: 522, name: 'Ghassira', nameAr: 'غسيرة' },
    { id: 523, name: 'Gosbat', nameAr: 'القصبات' },
    { id: 524, name: 'Guigba', nameAr: 'القيقبة' },
    { id: 525, name: 'Hidoussa', nameAr: 'حيدوسة' },
    { id: 526, name: 'Ichemoul', nameAr: 'إشمول' },
    { id: 527, name: 'Inoughissen', nameAr: 'إينوغيسن' },
    { id: 528, name: 'Kimmel', nameAr: 'كيمل' },
    { id: 529, name: 'Ksar Bellezma', nameAr: 'قصر بلزمة' },
    { id: 530, name: 'Larbaa', nameAr: 'لارباع' },
    { id: 531, name: 'Lazrou', nameAr: 'لازرو' },
    { id: 532, name: 'Lemcene', nameAr: 'لمسان' },
    { id: 533, name: 'M Doukal', nameAr: 'إمدوكل' },
    { id: 534, name: 'Maafa', nameAr: 'معافة' },
    { id: 535, name: 'Menaa', nameAr: 'منعة' },
    { id: 536, name: 'Merouana', nameAr: 'مروانة' },
    { id: 537, name: 'N Gaous', nameAr: 'نقاوس' },
    { id: 538, name: 'Oued Chaaba', nameAr: 'وادي الشعبة' },
    { id: 539, name: 'Oued El Ma', nameAr: 'وادي الماء' },
    { id: 540, name: 'Oued Taga', nameAr: 'وادي الطاقة' },
    { id: 541, name: 'Ouled Ammar', nameAr: 'أولاد عمار' },
    { id: 542, name: 'Ouled Aouf', nameAr: 'أولاد عوف' },
    { id: 543, name: 'Ouled Fadel', nameAr: 'أولاد فاضل' },
    { id: 544, name: 'Ouled Sellem', nameAr: 'أولاد سلام' },
    { id: 545, name: 'Ouled Si Slimane', nameAr: 'أولاد سي سليمان' },
    { id: 546, name: 'Ouyoun El Assafir', nameAr: 'عيون العصافير' },
    { id: 547, name: 'Rahbat', nameAr: 'الرحبات' },
    { id: 548, name: 'Ras El Aioun', nameAr: 'رأس العيون' },
    { id: 549, name: 'Sefiane', nameAr: 'سفيان' },
    { id: 550, name: 'Seggana', nameAr: 'سقانة' },
    { id: 551, name: 'Seriana', nameAr: 'سريانة' },
    { id: 552, name: 'T Kout', nameAr: 'تكوت' },
    { id: 553, name: 'Talkhamt', nameAr: 'تالخمت' },
    { id: 554, name: 'Taxlent', nameAr: 'تاكسلانت' },
    { id: 555, name: 'Tazoult', nameAr: 'تازولت' },
    { id: 556, name: 'Teniet El Abed', nameAr: 'ثنية العابد' },
    { id: 557, name: 'Tighanimine', nameAr: 'تيغانمين' },
    { id: 558, name: 'Tigharghar', nameAr: 'تغرغار' },
    { id: 559, name: 'Tilatou', nameAr: 'تيلاطو' },
    { id: 560, name: 'Timgad', nameAr: 'تيمقاد' },
    { id: 561, name: 'Zanet El Beida', nameAr: 'زانة البيضاء' },
  ],
  6: [
    { id: 601, name: 'Adekar', nameAr: 'أدكار' },
    { id: 602, name: 'Ait R\'zine', nameAr: 'أيت رزين' },
    { id: 603, name: 'Ait-Smail', nameAr: 'أيت إسماعيل' },
    { id: 604, name: 'Akbou', nameAr: 'أقبو' },
    { id: 605, name: 'Akfadou', nameAr: 'أكفادو' },
    { id: 606, name: 'Amalou', nameAr: 'أمالو' },
    { id: 607, name: 'Amizour', nameAr: 'أميزور' },
    { id: 608, name: 'Aokas', nameAr: 'أوقاس' },
    { id: 609, name: 'Barbacha', nameAr: 'برباشة' },
    { id: 610, name: 'Bejaia', nameAr: 'بجاية' },
    { id: 611, name: 'Beni Djellil', nameAr: 'بني جليل' },
    { id: 612, name: 'Beni K\'sila', nameAr: 'بني كسيلة' },
    { id: 613, name: 'Beni-Mallikeche', nameAr: 'بني مليكش' },
    { id: 614, name: 'Benimaouche', nameAr: 'بني معوش' },
    { id: 615, name: 'Boudjellil', nameAr: 'بو جليل' },
    { id: 616, name: 'Bouhamza', nameAr: 'بوحمزة' },
    { id: 617, name: 'Boukhelifa', nameAr: 'بوخليفة' },
    { id: 618, name: 'Chellata', nameAr: 'شلاطة' },
    { id: 619, name: 'Chemini', nameAr: 'شميني' },
    { id: 620, name: 'Darguina', nameAr: 'درقينة' },
    { id: 621, name: 'Dra El Caid', nameAr: 'ذراع القايد' },
    { id: 622, name: 'El Kseur', nameAr: 'القصر' },
    { id: 623, name: 'Fenaia Il Maten', nameAr: 'فناية الماثن' },
    { id: 624, name: 'Feraoun', nameAr: 'فرعون' },
    { id: 625, name: 'Ighil-Ali', nameAr: 'إغيل علي' },
    { id: 626, name: 'Ighram', nameAr: 'اغرم' },
    { id: 627, name: 'Kendira', nameAr: 'كنديرة' },
    { id: 628, name: 'Kherrata', nameAr: 'خراطة' },
    { id: 629, name: 'Leflaye', nameAr: 'الفلاي' },
    { id: 630, name: 'M\'cisna', nameAr: 'مسيسنة' },
    { id: 631, name: 'Melbou', nameAr: 'مالبو' },
    { id: 632, name: 'Oued Ghir', nameAr: 'وادي غير' },
    { id: 633, name: 'Ouzellaguen', nameAr: 'أوزلاقن' },
    { id: 634, name: 'Seddouk', nameAr: 'صدوق' },
    { id: 635, name: 'Sidi Ayad', nameAr: 'سيدي عياد' },
    { id: 636, name: 'Sidi-Aich', nameAr: 'سيدي عيش' },
    { id: 637, name: 'Smaoun', nameAr: 'سمعون' },
    { id: 638, name: 'Souk El Tenine', nameAr: 'سوق لإثنين' },
    { id: 639, name: 'Souk Oufella', nameAr: 'سوق اوفلا' },
    { id: 640, name: 'Tala Hamza', nameAr: 'تالة حمزة' },
    { id: 641, name: 'Tamokra', nameAr: 'تامقرة' },
    { id: 642, name: 'Tamridjet', nameAr: 'تامريجت' },
    { id: 643, name: 'Taourit Ighil', nameAr: 'تاوريرت إغيل' },
    { id: 644, name: 'Taskriout', nameAr: 'تاسكريوت' },
    { id: 645, name: 'Tazmalt', nameAr: 'تازمالت' },
    { id: 646, name: 'Tibane', nameAr: 'طيبان' },
    { id: 647, name: 'Tichy', nameAr: 'تيشي' },
    { id: 648, name: 'Tifra', nameAr: 'تيفرة' },
    { id: 649, name: 'Timezrit', nameAr: 'تيمزريت' },
    { id: 650, name: 'Tinebdar', nameAr: 'تينبدار' },
    { id: 651, name: 'Tizi-N\'berber', nameAr: 'تيزي نبربر' },
    { id: 652, name: 'Toudja', nameAr: 'توجة' },
  ],
  7: [
    { id: 701, name: 'Ain Naga', nameAr: 'عين الناقة' },
    { id: 702, name: 'Ain Zaatout', nameAr: 'عين زعطوط' },
    { id: 703, name: 'Biskra', nameAr: 'بسكرة' },
    { id: 704, name: 'Bordj Ben Azzouz', nameAr: 'برج بن عزوز' },
    { id: 705, name: 'Bouchakroun', nameAr: 'بوشقرون' },
    { id: 706, name: 'Branis', nameAr: 'برانيس' },
    { id: 707, name: 'Chetma', nameAr: 'شتمة' },
    { id: 708, name: 'Djemorah', nameAr: 'جمورة' },
    { id: 709, name: 'El Feidh', nameAr: 'الفيض' },
    { id: 710, name: 'El Ghrous', nameAr: 'الغروس' },
    { id: 711, name: 'El Hadjab', nameAr: 'الحاجب' },
    { id: 712, name: 'El Haouch', nameAr: 'الحوش' },
    { id: 713, name: 'El Kantara', nameAr: 'القنطرة' },
    { id: 714, name: 'El Outaya', nameAr: 'الوطاية' },
    { id: 715, name: 'Foughala', nameAr: 'فوغالة' },
    { id: 716, name: 'Khenguet Sidi Nadji', nameAr: 'خنقة سيدي ناجي' },
    { id: 717, name: 'Lichana', nameAr: 'ليشانة' },
    { id: 718, name: 'Lioua', nameAr: 'ليوة' },
    { id: 719, name: 'M\'chouneche', nameAr: 'مشونش' },
    { id: 720, name: 'M\'lili', nameAr: 'مليلي' },
    { id: 721, name: 'Mekhadma', nameAr: 'مخادمة' },
    { id: 722, name: 'Meziraa', nameAr: 'المزيرعة' },
    { id: 723, name: 'Oumache', nameAr: 'أوماش' },
    { id: 724, name: 'Ourlal', nameAr: 'أورلال' },
    { id: 725, name: 'Sidi Okba', nameAr: 'سيدي عقبة' },
    { id: 726, name: 'Tolga', nameAr: 'طولقة' },
    { id: 727, name: 'Zeribet El Oued', nameAr: 'زريبة الوادي' },
  ],
  8: [
    { id: 801, name: 'Abadla', nameAr: 'العبادلة' },
    { id: 802, name: 'Bechar', nameAr: 'بشار' },
    { id: 803, name: 'Beni-Ounif', nameAr: 'بني ونيف' },
    { id: 804, name: 'Boukais', nameAr: 'بوكايس' },
    { id: 805, name: 'Erg-Ferradj', nameAr: 'عرق فراج' },
    { id: 806, name: 'Kenadsa', nameAr: 'القنادسة' },
    { id: 807, name: 'Lahmar', nameAr: 'لحمر' },
    { id: 808, name: 'Machraa-Houari-Boumediene', nameAr: 'مشرع هواري بومدين' },
    { id: 809, name: 'Meridja', nameAr: 'المريجة' },
    { id: 810, name: 'Mogheul', nameAr: 'موغل' },
    { id: 811, name: 'Tabelbala', nameAr: 'تبلبالة' },
    { id: 812, name: 'Taghit', nameAr: 'تاغيت' },
  ],
  9: [
    { id: 901, name: 'Ain Romana', nameAr: 'عين الرمانة' },
    { id: 902, name: 'Beni Mered', nameAr: 'بني مراد' },
    { id: 903, name: 'Beni-Tamou', nameAr: 'بني تامو' },
    { id: 904, name: 'Benkhelil', nameAr: 'بن خليل' },
    { id: 905, name: 'Blida', nameAr: 'البليدة' },
    { id: 906, name: 'Bouarfa', nameAr: 'بوعرفة' },
    { id: 907, name: 'Boufarik', nameAr: 'بوفاريك' },
    { id: 908, name: 'Bougara', nameAr: 'بوقرة' },
    { id: 909, name: 'Bouinan', nameAr: 'بوعينان' },
    { id: 910, name: 'Chebli', nameAr: 'الشبلي' },
    { id: 911, name: 'Chiffa', nameAr: 'الشفة' },
    { id: 912, name: 'Chrea', nameAr: 'الشريعة' },
    { id: 913, name: 'Djebabra', nameAr: 'جبابرة' },
    { id: 914, name: 'El-Affroun', nameAr: 'العفرون' },
    { id: 915, name: 'Guerrouaou', nameAr: 'قرواو' },
    { id: 916, name: 'Hammam Elouane', nameAr: 'حمام ملوان' },
    { id: 917, name: 'Larbaa', nameAr: 'الأربعاء' },
    { id: 918, name: 'Meftah', nameAr: 'مفتاح' },
    { id: 919, name: 'Mouzaia', nameAr: 'موزاية' },
    { id: 920, name: 'Oued  Djer', nameAr: 'وادي جر' },
    { id: 921, name: 'Oued El Alleug', nameAr: 'وادي العلايق' },
    { id: 922, name: 'Ouled Slama', nameAr: 'اولاد سلامة' },
    { id: 923, name: 'Ouled Yaich', nameAr: 'أولاد يعيش' },
    { id: 924, name: 'Souhane', nameAr: 'صوحان' },
    { id: 925, name: 'Soumaa', nameAr: 'الصومعة' },
  ],
  10: [
    { id: 1001, name: 'Aghbalou', nameAr: 'أغبالو' },
    { id: 1002, name: 'Ahl El Ksar', nameAr: 'أهل القصر' },
    { id: 1003, name: 'Ain El Hadjar', nameAr: 'عين الحجر' },
    { id: 1004, name: 'Ain Laloui', nameAr: 'عين العلوي' },
    { id: 1005, name: 'Ain Turk', nameAr: 'عين الترك' },
    { id: 1006, name: 'Ain-Bessem', nameAr: 'عين بسام' },
    { id: 1007, name: 'Ait Laaziz', nameAr: 'أيت لعزيز' },
    { id: 1008, name: 'Aomar', nameAr: 'أعمر' },
    { id: 1009, name: 'Ath Mansour', nameAr: 'آث  منصور' },
    { id: 1010, name: 'Bechloul', nameAr: 'بشلول' },
    { id: 1011, name: 'Bir Ghbalou', nameAr: 'بئر غبالو' },
    { id: 1012, name: 'Bordj Okhriss', nameAr: 'برج أوخريص' },
    { id: 1013, name: 'Bouderbala', nameAr: 'بودربالة' },
    { id: 1014, name: 'Bouira', nameAr: 'البويرة' },
    { id: 1015, name: 'Boukram', nameAr: 'بوكرم' },
    { id: 1016, name: 'Chorfa', nameAr: 'شرفة' },
    { id: 1017, name: 'Dechmia', nameAr: 'الدشمية' },
    { id: 1018, name: 'Dirah', nameAr: 'ديرة' },
    { id: 1019, name: 'Djebahia', nameAr: 'جباحية' },
    { id: 1020, name: 'El Adjiba', nameAr: 'العجيبة' },
    { id: 1021, name: 'El Asnam', nameAr: 'الأسنام' },
    { id: 1022, name: 'El Hachimia', nameAr: 'الهاشمية' },
    { id: 1023, name: 'El Khabouzia', nameAr: 'الخبوزية' },
    { id: 1024, name: 'El-Hakimia', nameAr: 'الحاكمية' },
    { id: 1025, name: 'El-Mokrani', nameAr: 'المقراني' },
    { id: 1026, name: 'Guerrouma', nameAr: 'قرومة' },
    { id: 1027, name: 'Hadjera Zerga', nameAr: 'الحجرة الزرقاء' },
    { id: 1028, name: 'Haizer', nameAr: 'حيزر' },
    { id: 1029, name: 'Hanif', nameAr: 'حنيف' },
    { id: 1030, name: 'Kadiria', nameAr: 'قادرية' },
    { id: 1031, name: 'Lakhdaria', nameAr: 'الأخضرية' },
    { id: 1032, name: 'M Chedallah', nameAr: 'أمشدالة' },
    { id: 1033, name: 'Maala', nameAr: 'معلة' },
    { id: 1034, name: 'Maamora', nameAr: 'المعمورة' },
    { id: 1035, name: 'Mezdour', nameAr: 'مزدور' },
    { id: 1036, name: 'Oued El Berdi', nameAr: 'وادي البردي' },
    { id: 1037, name: 'Ouled Rached', nameAr: 'أولاد راشد' },
    { id: 1038, name: 'Raouraoua', nameAr: 'روراوة' },
    { id: 1039, name: 'Ridane', nameAr: 'ريدان' },
    { id: 1040, name: 'Saharidj', nameAr: 'سحاريج' },
    { id: 1041, name: 'Souk El Khemis', nameAr: 'سوق الخميس' },
    { id: 1042, name: 'Sour El Ghozlane', nameAr: 'سور الغزلان' },
    { id: 1043, name: 'Taghzout', nameAr: 'تاغزوت' },
    { id: 1044, name: 'Taguedite', nameAr: 'تاقديت' },
    { id: 1045, name: 'Z\'barbar (El Isseri )', nameAr: 'زبربر' },
  ],
  11: [
    { id: 1101, name: 'Abelsa', nameAr: 'ابلسة' },
    { id: 1102, name: 'Ain Amguel', nameAr: 'عين امقل' },
    { id: 1103, name: 'Idles', nameAr: 'أدلس' },
    { id: 1104, name: 'Tamanrasset', nameAr: 'تمنراست' },
    { id: 1105, name: 'Tazrouk', nameAr: 'تاظروك' },
  ],
  12: [
    { id: 1201, name: 'Ain Zerga', nameAr: 'عين الزرقاء' },
    { id: 1202, name: 'Bedjene', nameAr: 'بجن' },
    { id: 1203, name: 'Bekkaria', nameAr: 'بكارية' },
    { id: 1204, name: 'Bir Dheheb', nameAr: 'بئر الذهب' },
    { id: 1205, name: 'Bir Mokkadem', nameAr: 'بئر مقدم' },
    { id: 1206, name: 'Bir-El-Ater', nameAr: 'بئر العاتر' },
    { id: 1207, name: 'Boukhadra', nameAr: 'بوخضرة' },
    { id: 1208, name: 'Boulhaf Dyr', nameAr: 'بولحاف الدير' },
    { id: 1209, name: 'Cheria', nameAr: 'الشريعة' },
    { id: 1210, name: 'El Kouif', nameAr: 'الكويف' },
    { id: 1211, name: 'El Malabiod', nameAr: 'الماء الابيض' },
    { id: 1212, name: 'El Meridj', nameAr: 'المريج' },
    { id: 1213, name: 'El Mezeraa', nameAr: 'المزرعة' },
    { id: 1214, name: 'El Ogla', nameAr: 'العقلة' },
    { id: 1215, name: 'El Ogla El Malha', nameAr: 'العقلة المالحة' },
    { id: 1216, name: 'El-Aouinet', nameAr: 'العوينات' },
    { id: 1217, name: 'El-Houidjbet', nameAr: 'الحويجبات' },
    { id: 1218, name: 'Ferkane', nameAr: 'فركان' },
    { id: 1219, name: 'Guorriguer', nameAr: 'قريقر' },
    { id: 1220, name: 'Hammamet', nameAr: 'الحمامات' },
    { id: 1221, name: 'Morsott', nameAr: 'مرسط' },
    { id: 1222, name: 'Negrine', nameAr: 'نقرين' },
    { id: 1223, name: 'Ouenza', nameAr: 'الونزة' },
    { id: 1224, name: 'Oum Ali', nameAr: 'أم علي' },
    { id: 1225, name: 'Saf Saf El Ouesra', nameAr: 'صفصاف الوسرى' },
    { id: 1226, name: 'Stah Guentis', nameAr: 'سطح قنطيس' },
    { id: 1227, name: 'Tebessa', nameAr: 'تبسة' },
    { id: 1228, name: 'Telidjen', nameAr: 'ثليجان' },
  ],
  13: [
    { id: 1301, name: 'Ain Fetah', nameAr: 'عين فتاح' },
    { id: 1302, name: 'Ain Fezza', nameAr: 'عين فزة' },
    { id: 1303, name: 'Ain Ghoraba', nameAr: 'عين غرابة' },
    { id: 1304, name: 'Ain Kebira', nameAr: 'عين الكبيرة' },
    { id: 1305, name: 'Ain Nehala', nameAr: 'عين النحالة' },
    { id: 1306, name: 'Ain Tellout', nameAr: 'عين تالوت' },
    { id: 1307, name: 'Ain Youcef', nameAr: 'عين يوسف' },
    { id: 1308, name: 'Amieur', nameAr: 'عمير' },
    { id: 1309, name: 'Azail', nameAr: 'العزايل' },
    { id: 1310, name: 'Bab El Assa', nameAr: 'باب العسة' },
    { id: 1311, name: 'Beni Bahdel', nameAr: 'بني بهدل' },
    { id: 1312, name: 'Beni Boussaid', nameAr: 'بني بوسعيد' },
    { id: 1313, name: 'Beni Khellad', nameAr: 'بني خلاد' },
    { id: 1314, name: 'Beni Mester', nameAr: 'بني مستر' },
    { id: 1315, name: 'Beni Ouarsous', nameAr: 'بني وارسوس' },
    { id: 1316, name: 'Beni Smiel', nameAr: 'بني صميل' },
    { id: 1317, name: 'Beni Snous', nameAr: 'بني سنوس' },
    { id: 1318, name: 'Bensekrane', nameAr: 'بن سكران' },
    { id: 1319, name: 'Bouhlou', nameAr: 'بوحلو' },
    { id: 1320, name: 'Bouihi', nameAr: 'البويهي' },
    { id: 1321, name: 'Chetouane', nameAr: 'شتوان' },
    { id: 1322, name: 'Dar Yaghmoracen', nameAr: 'دار يغمراسن' },
    { id: 1323, name: 'Djebala', nameAr: 'جبالة' },
    { id: 1324, name: 'El Aricha', nameAr: 'العريشة' },
    { id: 1325, name: 'El Fehoul', nameAr: 'الفحول' },
    { id: 1326, name: 'El Gor', nameAr: 'القور' },
    { id: 1327, name: 'Fellaoucene', nameAr: 'فلاوسن' },
    { id: 1328, name: 'Ghazaouet', nameAr: 'الغزوات' },
    { id: 1329, name: 'Hammam Boughrara', nameAr: 'حمام بوغرارة' },
    { id: 1330, name: 'Hennaya', nameAr: 'الحناية' },
    { id: 1331, name: 'Honnaine', nameAr: 'هنين' },
    { id: 1332, name: 'M\'sirda Fouaga', nameAr: 'مسيردة الفواقة' },
    { id: 1333, name: 'Maghnia', nameAr: 'مغنية' },
    { id: 1334, name: 'Mansourah', nameAr: 'منصورة' },
    { id: 1335, name: 'Marsa Ben M\'hidi', nameAr: 'مرسى بن مهيدي' },
    { id: 1336, name: 'Nedroma', nameAr: 'ندرومة' },
    { id: 1337, name: 'Oued Lakhdar', nameAr: 'وادي الخضر' },
    { id: 1338, name: 'Ouled Mimoun', nameAr: 'أولاد ميمون' },
    { id: 1339, name: 'Ouled Riyah', nameAr: 'أولاد رياح' },
    { id: 1340, name: 'Remchi', nameAr: 'الرمشي' },
    { id: 1341, name: 'Sabra', nameAr: 'صبرة' },
    { id: 1342, name: 'Sebbaa Chioukh', nameAr: 'سبعة شيوخ' },
    { id: 1343, name: 'Sebdou', nameAr: 'سبدو' },
    { id: 1344, name: 'Sidi Abdelli', nameAr: 'سيدي العبدلي' },
    { id: 1345, name: 'Sidi Djillali', nameAr: 'سيدي الجيلالي' },
    { id: 1346, name: 'Sidi Medjahed', nameAr: 'سيدي مجاهد' },
    { id: 1347, name: 'Souahlia', nameAr: 'السواحلية' },
    { id: 1348, name: 'Souani', nameAr: 'السواني' },
    { id: 1349, name: 'Souk Tleta', nameAr: 'سوق الثلاثاء' },
    { id: 1350, name: 'Terny Beni Hediel', nameAr: 'تيرني بني هديل' },
    { id: 1351, name: 'Tianet', nameAr: 'تيانت' },
    { id: 1352, name: 'Tlemcen', nameAr: 'تلمسان' },
    { id: 1353, name: 'Zenata', nameAr: 'زناتة' },
  ],
  14: [
    { id: 1401, name: 'Ain Bouchekif', nameAr: 'عين بوشقيف' },
    { id: 1402, name: 'Ain Deheb', nameAr: 'عين الذهب' },
    { id: 1403, name: 'Ain Dzarit', nameAr: 'عين دزاريت' },
    { id: 1404, name: 'Ain El Hadid', nameAr: 'عين الحديد' },
    { id: 1405, name: 'Ain Kermes', nameAr: 'عين كرمس' },
    { id: 1406, name: 'Bougara', nameAr: 'بوقرة' },
    { id: 1407, name: 'Chehaima', nameAr: 'شحيمة' },
    { id: 1408, name: 'Dahmouni', nameAr: 'دحموني' },
    { id: 1409, name: 'Djebilet Rosfa', nameAr: 'جبيلات الرصفاء' },
    { id: 1410, name: 'Djillali Ben Amar', nameAr: 'جيلالي بن عمار' },
    { id: 1411, name: 'Faidja', nameAr: 'الفايجة' },
    { id: 1412, name: 'Frenda', nameAr: 'فرندة' },
    { id: 1413, name: 'Guertoufa', nameAr: 'قرطوفة' },
    { id: 1414, name: 'Hamadia', nameAr: 'حمادية' },
    { id: 1415, name: 'Ksar Chellala', nameAr: 'قصر الشلالة' },
    { id: 1416, name: 'Madna', nameAr: 'مادنة' },
    { id: 1417, name: 'Mahdia', nameAr: 'مهدية' },
    { id: 1418, name: 'Mechraa Safa', nameAr: 'مشرع الصفا' },
    { id: 1419, name: 'Medrissa', nameAr: 'مدريسة' },
    { id: 1420, name: 'Medroussa', nameAr: 'مدروسة' },
    { id: 1421, name: 'Meghila', nameAr: 'مغيلة' },
    { id: 1422, name: 'Mellakou', nameAr: 'ملاكو' },
    { id: 1423, name: 'Nadorah', nameAr: 'الناظورة' },
    { id: 1424, name: 'Naima', nameAr: 'النعيمة' },
    { id: 1425, name: 'Oued Lilli', nameAr: 'وادي ليلي' },
    { id: 1426, name: 'Rahouia', nameAr: 'الرحوية' },
    { id: 1427, name: 'Rechaiga', nameAr: 'الرشايقة' },
    { id: 1428, name: 'Sebaine', nameAr: 'السبعين' },
    { id: 1429, name: 'Sebt', nameAr: 'السبت' },
    { id: 1430, name: 'Serghine', nameAr: 'سرغين' },
    { id: 1431, name: 'Si Abdelghani', nameAr: 'سي عبد الغني' },
    { id: 1432, name: 'Sidi Abderrahmane', nameAr: 'سيدي عبد الرحمن' },
    { id: 1433, name: 'Sidi Ali Mellal', nameAr: 'سيدي علي ملال' },
    { id: 1434, name: 'Sidi Bakhti', nameAr: 'سيدي بختي' },
    { id: 1435, name: 'Sidi Hosni', nameAr: 'سيدي حسني' },
    { id: 1436, name: 'Sougueur', nameAr: 'السوقر' },
    { id: 1437, name: 'Tagdempt', nameAr: 'تاقدمت' },
    { id: 1438, name: 'Takhemaret', nameAr: 'تخمرت' },
    { id: 1439, name: 'Tiaret', nameAr: 'تيارت' },
    { id: 1440, name: 'Tidda', nameAr: 'تيدة' },
    { id: 1441, name: 'Tousnina', nameAr: 'توسنينة' },
    { id: 1442, name: 'Zmalet El Emir Abdelkade', nameAr: 'زمالة  الأمير عبد القادر' },
  ],
  15: [
    { id: 1501, name: 'Abi-Youcef', nameAr: 'أبي يوسف' },
    { id: 1502, name: 'Aghribs', nameAr: 'أغريب' },
    { id: 1503, name: 'Agouni-Gueghrane', nameAr: 'أقني قغران' },
    { id: 1504, name: 'Ain-El-Hammam', nameAr: 'عين الحمام' },
    { id: 1505, name: 'Ain-Zaouia', nameAr: 'عين الزاوية' },
    { id: 1506, name: 'Ait Aggouacha', nameAr: 'أيت عقـواشة' },
    { id: 1507, name: 'Ait Bouaddou', nameAr: 'أيت بــوادو' },
    { id: 1508, name: 'Ait Boumahdi', nameAr: 'أيت بومهدي' },
    { id: 1509, name: 'Ait Khellili', nameAr: 'أيت خليلي' },
    { id: 1510, name: 'Ait Yahia Moussa', nameAr: 'أيت يحي موسى' },
    { id: 1511, name: 'Ait-Aissa-Mimoun', nameAr: 'أيت عيسى ميمون' },
    { id: 1512, name: 'Ait-Chafaa', nameAr: 'أيت شافع' },
    { id: 1513, name: 'Ait-Mahmoud', nameAr: 'أيت محمود' },
    { id: 1514, name: 'Ait-Oumalou', nameAr: 'أيت  أومالو' },
    { id: 1515, name: 'Ait-Toudert', nameAr: 'أيت تودرت' },
    { id: 1516, name: 'Ait-Yahia', nameAr: 'أيت يحيى' },
    { id: 1517, name: 'Akbil', nameAr: 'اقبيل' },
    { id: 1518, name: 'Akerrou', nameAr: 'أقرو' },
    { id: 1519, name: 'Assi-Youcef', nameAr: 'أسي يوسف' },
    { id: 1520, name: 'Azazga', nameAr: 'عزازقة' },
    { id: 1521, name: 'Azeffoun', nameAr: 'أزفون' },
    { id: 1522, name: 'Beni Zmenzer', nameAr: 'بنــــي زمنزار' },
    { id: 1523, name: 'Beni-Aissi', nameAr: 'بني عيسي' },
    { id: 1524, name: 'Beni-Douala', nameAr: 'بني دوالة' },
    { id: 1525, name: 'Beni-Yenni', nameAr: 'بني يني' },
    { id: 1526, name: 'Beni-Zikki', nameAr: 'بني زيكــي' },
    { id: 1527, name: 'Boghni', nameAr: 'بوغني' },
    { id: 1528, name: 'Boudjima', nameAr: 'بوجيمة' },
    { id: 1529, name: 'Bounouh', nameAr: 'بونوح' },
    { id: 1530, name: 'Bouzeguene', nameAr: 'بوزقــن' },
    { id: 1531, name: 'Draa-Ben-Khedda', nameAr: 'ذراع بن خدة' },
    { id: 1532, name: 'Draa-El-Mizan', nameAr: 'ذراع الميزان' },
    { id: 1533, name: 'Freha', nameAr: 'فريحة' },
    { id: 1534, name: 'Frikat', nameAr: 'فريقات' },
    { id: 1535, name: 'Iboudrarene', nameAr: 'إبودرارن' },
    { id: 1536, name: 'Idjeur', nameAr: 'إيجــار' },
    { id: 1537, name: 'Iferhounene', nameAr: 'إفــرحــونان' },
    { id: 1538, name: 'Ifigha', nameAr: 'إيفيغاء' },
    { id: 1539, name: 'Iflissen', nameAr: 'إفليـــسن' },
    { id: 1540, name: 'Illilten', nameAr: 'إيلـيــلتـن' },
    { id: 1541, name: 'Illoula Oumalou', nameAr: 'إيلولة أومـــالو' },
    { id: 1542, name: 'Imsouhal', nameAr: 'إمســوحال' },
    { id: 1543, name: 'Irdjen', nameAr: 'إيرجـــن' },
    { id: 1544, name: 'Larbaa Nath Irathen', nameAr: 'الأربعــاء ناث إيراثن' },
    { id: 1545, name: 'M\'kira', nameAr: 'مكيرة' },
    { id: 1546, name: 'Maatkas', nameAr: 'معـــاتقة' },
    { id: 1547, name: 'Makouda', nameAr: 'ماكودة' },
    { id: 1548, name: 'Mechtras', nameAr: 'مشطراس' },
    { id: 1549, name: 'Mekla', nameAr: 'مقــلع' },
    { id: 1550, name: 'Mizrana', nameAr: 'ميزرانـــة' },
    { id: 1551, name: 'Ouacif', nameAr: 'واسيف' },
    { id: 1552, name: 'Ouadhias', nameAr: 'واضية' },
    { id: 1553, name: 'Ouaguenoun', nameAr: 'واقنون' },
    { id: 1554, name: 'Sidi Namane', nameAr: 'سيدي نعمان' },
    { id: 1555, name: 'Souama', nameAr: 'صوامـــع' },
    { id: 1556, name: 'Souk-El-Tenine', nameAr: 'سوق الإثنين' },
    { id: 1557, name: 'Tadmait', nameAr: 'تادمايت' },
    { id: 1558, name: 'Tigzirt', nameAr: 'تيقـزيرت' },
    { id: 1559, name: 'Timizart', nameAr: 'تيمـيزار' },
    { id: 1560, name: 'Tirmitine', nameAr: 'تيرمتين' },
    { id: 1561, name: 'Tizi N\'tleta', nameAr: 'تيزي نثلاثة' },
    { id: 1562, name: 'Tizi-Gheniff', nameAr: 'تيزي غنيف' },
    { id: 1563, name: 'Tizi-Ouzou', nameAr: 'تيزي وزو' },
    { id: 1564, name: 'Tizi-Rached', nameAr: 'تيزي راشد' },
    { id: 1565, name: 'Yakourene', nameAr: 'إعــكورن' },
    { id: 1566, name: 'Yatafene', nameAr: 'يطــافن' },
    { id: 1567, name: 'Zekri', nameAr: 'زكري' },
  ],
  16: [
    { id: 1601, name: 'Ain Benian', nameAr: 'عين بنيان' },
    { id: 1602, name: 'Ain Taya', nameAr: 'عين طاية' },
    { id: 1603, name: 'Alger Centre', nameAr: 'الجزائر الوسطى' },
    { id: 1604, name: 'Bab El Oued', nameAr: 'باب الوادي' },
    { id: 1605, name: 'Bab Ezzouar', nameAr: 'باب الزوار' },
    { id: 1606, name: 'Baba Hassen', nameAr: 'بابا حسن' },
    { id: 1607, name: 'Bachedjerah', nameAr: 'باش جراح' },
    { id: 1608, name: 'Baraki', nameAr: 'براقي' },
    { id: 1609, name: 'Ben Aknoun', nameAr: 'ابن عكنون' },
    { id: 1610, name: 'Beni Messous', nameAr: 'بني مسوس' },
    { id: 1611, name: 'Bir Mourad Rais', nameAr: 'بئر مراد رايس' },
    { id: 1612, name: 'Bir Touta', nameAr: 'بئر توتة' },
    { id: 1613, name: 'Birkhadem', nameAr: 'بئر خادم' },
    { id: 1614, name: 'Bologhine Ibnou Ziri', nameAr: 'بولوغين بن زيري' },
    { id: 1615, name: 'Bordj El Bahri', nameAr: 'برج البحري' },
    { id: 1616, name: 'Bordj El Kiffan', nameAr: 'برج الكيفان' },
    { id: 1617, name: 'Bourouba', nameAr: 'بوروبة' },
    { id: 1618, name: 'Bouzareah', nameAr: 'بوزريعة' },
    { id: 1619, name: 'Casbah', nameAr: 'القصبة' },
    { id: 1620, name: 'Cheraga', nameAr: 'الشراقة' },
    { id: 1621, name: 'Dar El Beida', nameAr: 'الدار البيضاء' },
    { id: 1622, name: 'Dely Ibrahim', nameAr: 'دالي ابراهيم' },
    { id: 1623, name: 'Djasr Kasentina', nameAr: 'جسر قسنطينة' },
    { id: 1624, name: 'Douira', nameAr: 'الدويرة' },
    { id: 1625, name: 'Draria', nameAr: 'الدرارية' },
    { id: 1626, name: 'El Achour', nameAr: 'العاشور' },
    { id: 1627, name: 'El Biar', nameAr: 'الابيار' },
    { id: 1628, name: 'El Harrach', nameAr: 'الحراش' },
    { id: 1629, name: 'El Madania', nameAr: 'المدنية' },
    { id: 1630, name: 'El Magharia', nameAr: 'المغارية' },
    { id: 1631, name: 'El Marsa', nameAr: 'المرسى' },
    { id: 1632, name: 'El Mouradia', nameAr: 'المرادية' },
    { id: 1633, name: 'Hammamet', nameAr: 'الحمامات' },
    { id: 1634, name: 'Herraoua', nameAr: 'هراوة' },
    { id: 1635, name: 'Hussein Dey', nameAr: 'حسين داي' },
    { id: 1636, name: 'Hydra', nameAr: 'حيدرة' },
    { id: 1637, name: 'Khraissia', nameAr: 'الخرايسية' },
    { id: 1638, name: 'Kouba', nameAr: 'القبة' },
    { id: 1639, name: 'Les Eucalyptus', nameAr: 'الكاليتوس' },
    { id: 1640, name: 'Maalma', nameAr: 'المعالمة' },
    { id: 1641, name: 'Mohamed Belouzdad', nameAr: 'محمد بلوزداد' },
    { id: 1642, name: 'Mohammadia', nameAr: 'المحمدية' },
    { id: 1643, name: 'Oued Koriche', nameAr: 'وادي قريش' },
    { id: 1644, name: 'Oued Smar', nameAr: 'وادي السمار' },
    { id: 1645, name: 'Ouled Chebel', nameAr: 'اولاد شبل' },
    { id: 1646, name: 'Ouled Fayet', nameAr: 'اولاد فايت' },
    { id: 1647, name: 'Rahmania', nameAr: 'الرحمانية' },
    { id: 1648, name: 'Rais Hamidou', nameAr: 'الرايس حميدو' },
    { id: 1649, name: 'Reghaia', nameAr: 'رغاية' },
    { id: 1650, name: 'Rouiba', nameAr: 'الرويبة' },
    { id: 1651, name: 'Sehaoula', nameAr: 'السحاولة' },
    { id: 1652, name: 'Sidi M\'hamed', nameAr: 'سيدي امحمد' },
    { id: 1653, name: 'Sidi Moussa', nameAr: 'سيدي موسى' },
    { id: 1654, name: 'Souidania', nameAr: 'سويدانية' },
    { id: 1655, name: 'Staoueli', nameAr: 'سطاوالي' },
    { id: 1656, name: 'Tessala El Merdja', nameAr: 'تسالة المرجة' },
    { id: 1657, name: 'Zeralda', nameAr: 'زرالدة' },
  ],
  17: [
    { id: 1701, name: 'Ain Chouhada', nameAr: 'عين الشهداء' },
    { id: 1702, name: 'Ain El Ibel', nameAr: 'عين الإبل' },
    { id: 1703, name: 'Ain Fekka', nameAr: 'عين فقه' },
    { id: 1704, name: 'Ain Maabed', nameAr: 'عين معبد' },
    { id: 1705, name: 'Ain Oussera', nameAr: 'عين وسارة' },
    { id: 1706, name: 'Amourah', nameAr: 'عمورة' },
    { id: 1707, name: 'Benhar', nameAr: 'بنهار' },
    { id: 1708, name: 'Benyagoub', nameAr: 'بن يعقوب' },
    { id: 1709, name: 'Birine', nameAr: 'بيرين' },
    { id: 1710, name: 'Bouira Lahdab', nameAr: 'بويرة الأحداب' },
    { id: 1711, name: 'Charef', nameAr: 'الشارف' },
    { id: 1712, name: 'Dar Chioukh', nameAr: 'دار الشيوخ' },
    { id: 1713, name: 'Deldoul', nameAr: 'دلدول' },
    { id: 1714, name: 'Djelfa', nameAr: 'الجلفة' },
    { id: 1715, name: 'Douis', nameAr: 'دويس' },
    { id: 1716, name: 'El Guedid', nameAr: 'القديد' },
    { id: 1717, name: 'El Idrissia', nameAr: 'الادريسية' },
    { id: 1718, name: 'El Khemis', nameAr: 'الخميس' },
    { id: 1719, name: 'Faidh El Botma', nameAr: 'فيض البطمة' },
    { id: 1720, name: 'Guernini', nameAr: 'قرنيني' },
    { id: 1721, name: 'Guettara', nameAr: 'قطارة' },
    { id: 1722, name: 'Had Sahary', nameAr: 'حد الصحاري' },
    { id: 1723, name: 'Hassi Bahbah', nameAr: 'حاسي بحبح' },
    { id: 1724, name: 'Hassi El Euch', nameAr: 'حاسي العش' },
    { id: 1725, name: 'Hassi Fedoul', nameAr: 'حاسي فدول' },
    { id: 1726, name: 'M\'liliha', nameAr: 'مليليحة' },
    { id: 1727, name: 'Messaad', nameAr: 'مسعد' },
    { id: 1728, name: 'Moudjebara', nameAr: 'مجبارة' },
    { id: 1729, name: 'Oum Laadham', nameAr: 'أم العظام' },
    { id: 1730, name: 'Sed Rahal', nameAr: 'سد الرحال' },
    { id: 1731, name: 'Selmana', nameAr: 'سلمانة' },
    { id: 1732, name: 'Sidi Baizid', nameAr: 'سيدي بايزيد' },
    { id: 1733, name: 'Sidi Laadjel', nameAr: 'سيدي لعجال' },
    { id: 1734, name: 'Taadmit', nameAr: 'تعظميت' },
    { id: 1735, name: 'Zaafrane', nameAr: 'زعفران' },
    { id: 1736, name: 'Zaccar', nameAr: 'زكار' },
  ],
  18: [
    { id: 1801, name: 'Bordj T\'har', nameAr: 'برج الطهر' },
    { id: 1802, name: 'Boudria Beniyadjis', nameAr: 'بودريعة بني  ياجيس' },
    { id: 1803, name: 'Bouraoui Belhadef', nameAr: 'بوراوي بلهادف' },
    { id: 1804, name: 'Boussif Ouled Askeur', nameAr: 'بوسيف أولاد عسكر' },
    { id: 1805, name: 'Chahna', nameAr: 'الشحنة' },
    { id: 1806, name: 'Chekfa', nameAr: 'الشقفة' },
    { id: 1807, name: 'Djemaa Beni Habibi', nameAr: 'الجمعة بني حبيبي' },
    { id: 1808, name: 'Djimla', nameAr: 'جيملة' },
    { id: 1809, name: 'El Ancer', nameAr: 'العنصر' },
    { id: 1810, name: 'El Aouana', nameAr: 'العوانة' },
    { id: 1811, name: 'El Kennar Nouchfi', nameAr: 'القنار نشفي' },
    { id: 1812, name: 'El Milia', nameAr: 'الميلية' },
    { id: 1813, name: 'Emir Abdelkader', nameAr: 'الامير عبد القادر' },
    { id: 1814, name: 'Erraguene Souissi', nameAr: 'أراقن سويسي' },
    { id: 1815, name: 'Ghebala', nameAr: 'غبالة' },
    { id: 1816, name: 'Jijel', nameAr: 'جيجل' },
    { id: 1817, name: 'Kaous', nameAr: 'قاوس' },
    { id: 1818, name: 'Khiri Oued Adjoul', nameAr: 'خيري واد عجول' },
    { id: 1819, name: 'Oudjana', nameAr: 'وجانة' },
    { id: 1820, name: 'Ouled Rabah', nameAr: 'أولاد رابح' },
    { id: 1821, name: 'Ouled Yahia Khadrouch', nameAr: 'أولاد يحيى خدروش' },
    { id: 1822, name: 'Selma Benziada', nameAr: 'سلمى بن زيادة' },
    { id: 1823, name: 'Settara', nameAr: 'السطارة' },
    { id: 1824, name: 'Sidi Abdelaziz', nameAr: 'سيدي عبد العزيز' },
    { id: 1825, name: 'Sidi Marouf', nameAr: 'سيدي معروف' },
    { id: 1826, name: 'Taher', nameAr: 'الطاهير' },
    { id: 1827, name: 'Texenna', nameAr: 'تاكسنة' },
    { id: 1828, name: 'Ziama Mansouriah', nameAr: 'زيامة منصورية' },
  ],
  19: [
    { id: 1901, name: 'Ain Abessa', nameAr: 'عين عباسة' },
    { id: 1902, name: 'Ain Arnat', nameAr: 'عين أرنات' },
    { id: 1903, name: 'Ain Azel', nameAr: 'عين أزال' },
    { id: 1904, name: 'Ain El Kebira', nameAr: 'عين الكبيرة' },
    { id: 1905, name: 'Ain Lahdjar', nameAr: 'عين الحجر' },
    { id: 1906, name: 'Ain Oulmene', nameAr: 'عين ولمان' },
    { id: 1907, name: 'Ain-Legradj', nameAr: 'عين لقراج' },
    { id: 1908, name: 'Ain-Roua', nameAr: 'عين الروى' },
    { id: 1909, name: 'Ain-Sebt', nameAr: 'عين السبت' },
    { id: 1910, name: 'Ait Naoual Mezada', nameAr: 'أيت نوال مزادة' },
    { id: 1911, name: 'Ait-Tizi', nameAr: 'ايت تيزي' },
    { id: 1912, name: 'Amoucha', nameAr: 'عموشة' },
    { id: 1913, name: 'Babor', nameAr: 'بابور' },
    { id: 1914, name: 'Bazer-Sakra', nameAr: 'بازر سكرة' },
    { id: 1915, name: 'Beidha Bordj', nameAr: 'بيضاء برج' },
    { id: 1916, name: 'Bellaa', nameAr: 'بلاعة' },
    { id: 1917, name: 'Beni Chebana', nameAr: 'بني شبانة' },
    { id: 1918, name: 'Beni Fouda', nameAr: 'بني فودة' },
    { id: 1919, name: 'Beni Ourtilane', nameAr: 'بني ورتيلان' },
    { id: 1920, name: 'Beni Oussine', nameAr: 'بني وسين' },
    { id: 1921, name: 'Beni-Aziz', nameAr: 'بني عزيز' },
    { id: 1922, name: 'Beni-Mouhli', nameAr: 'بني موحلي' },
    { id: 1923, name: 'Bir Haddada', nameAr: 'بئر حدادة' },
    { id: 1924, name: 'Bir-El-Arch', nameAr: 'بئر العرش' },
    { id: 1925, name: 'Bouandas', nameAr: 'بوعنداس' },
    { id: 1926, name: 'Bougaa', nameAr: 'بوقاعة' },
    { id: 1927, name: 'Bousselam', nameAr: 'بوسلام' },
    { id: 1928, name: 'Boutaleb', nameAr: 'بوطالب' },
    { id: 1929, name: 'Dehamcha', nameAr: 'الدهامشة' },
    { id: 1930, name: 'Djemila', nameAr: 'جميلة' },
    { id: 1931, name: 'Draa-Kebila', nameAr: 'ذراع قبيلة' },
    { id: 1932, name: 'El Eulma', nameAr: 'العلمة' },
    { id: 1933, name: 'El Ouricia', nameAr: 'أوريسيا' },
    { id: 1934, name: 'El-Ouldja', nameAr: 'الولجة' },
    { id: 1935, name: 'Guellal', nameAr: 'قلال' },
    { id: 1936, name: 'Guelta Zerka', nameAr: 'قلتة زرقاء' },
    { id: 1937, name: 'Guenzet', nameAr: 'قنزات' },
    { id: 1938, name: 'Guidjel', nameAr: 'قجال' },
    { id: 1939, name: 'Hamam Soukhna', nameAr: 'حمام السخنة' },
    { id: 1940, name: 'Hamma', nameAr: 'الحامة' },
    { id: 1941, name: 'Hammam Guergour', nameAr: 'حمام قرقور' },
    { id: 1942, name: 'Harbil', nameAr: 'حربيل' },
    { id: 1943, name: 'Kasr El Abtal', nameAr: 'قصر الابطال' },
    { id: 1944, name: 'Maaouia', nameAr: 'معاوية' },
    { id: 1945, name: 'Maouaklane', nameAr: 'ماوكلان' },
    { id: 1946, name: 'Mezloug', nameAr: 'مزلوق' },
    { id: 1947, name: 'Oued El Bared', nameAr: 'واد البارد' },
    { id: 1948, name: 'Ouled Addouane', nameAr: 'أولاد عدوان' },
    { id: 1949, name: 'Ouled Sabor', nameAr: 'أولاد صابر' },
    { id: 1950, name: 'Ouled Si Ahmed', nameAr: 'أولاد سي أحمد' },
    { id: 1951, name: 'Ouled Tebben', nameAr: 'أولاد تبان' },
    { id: 1952, name: 'Rosfa', nameAr: 'الرصفة' },
    { id: 1953, name: 'Salah Bey', nameAr: 'صالح باي' },
    { id: 1954, name: 'Serdj-El-Ghoul', nameAr: 'سرج الغول' },
    { id: 1955, name: 'Setif', nameAr: 'سطيف' },
    { id: 1956, name: 'Tachouda', nameAr: 'تاشودة' },
    { id: 1957, name: 'Tala-Ifacene', nameAr: 'تالة إيفاسن' },
    { id: 1958, name: 'Taya', nameAr: 'الطاية' },
    { id: 1959, name: 'Tella', nameAr: 'التلة' },
    { id: 1960, name: 'Tizi N\'bechar', nameAr: 'تيزي نبشار' },
  ],
  20: [
    { id: 2001, name: 'Ain El Hadjar', nameAr: 'عين الحجر' },
    { id: 2002, name: 'Ain Sekhouna', nameAr: 'عين السخونة' },
    { id: 2003, name: 'Ain Soltane', nameAr: 'عين السلطان' },
    { id: 2004, name: 'Doui Thabet', nameAr: 'دوي ثابت' },
    { id: 2005, name: 'El Hassasna', nameAr: 'الحساسنة' },
    { id: 2006, name: 'Hounet', nameAr: 'هونت' },
    { id: 2007, name: 'Maamora', nameAr: 'المعمورة' },
    { id: 2008, name: 'Moulay Larbi', nameAr: 'مولاي العربي' },
    { id: 2009, name: 'Ouled Brahim', nameAr: 'أولاد إبراهيم' },
    { id: 2010, name: 'Ouled Khaled', nameAr: 'أولاد خالد' },
    { id: 2011, name: 'Saida', nameAr: 'سعيدة' },
    { id: 2012, name: 'Sidi Ahmed', nameAr: 'سيدي احمد' },
    { id: 2013, name: 'Sidi Amar', nameAr: 'سيدي عمر' },
    { id: 2014, name: 'Sidi Boubekeur', nameAr: 'سيدي بوبكر' },
    { id: 2015, name: 'Tircine', nameAr: 'تيرسين' },
    { id: 2016, name: 'Youb', nameAr: 'يوب' },
  ],
  21: [
    { id: 2101, name: 'Ain Bouziane', nameAr: 'عين بوزيان' },
    { id: 2102, name: 'Ain Charchar', nameAr: 'عين شرشار' },
    { id: 2103, name: 'Ain Kechra', nameAr: 'عين قشرة' },
    { id: 2104, name: 'Ain Zouit', nameAr: 'عين زويت' },
    { id: 2105, name: 'Azzaba', nameAr: 'عزابة' },
    { id: 2106, name: 'Bekkouche Lakhdar', nameAr: 'بكوش لخضر' },
    { id: 2107, name: 'Ben Azzouz', nameAr: 'بن عزوز' },
    { id: 2108, name: 'Beni Bechir', nameAr: 'بني بشير' },
    { id: 2109, name: 'Beni Oulbane', nameAr: 'بني ولبان' },
    { id: 2110, name: 'Beni Zid', nameAr: 'بني زيد' },
    { id: 2111, name: 'Bin El Ouiden', nameAr: 'بين الويدان' },
    { id: 2112, name: 'Bouchetata', nameAr: 'بوشطاطة' },
    { id: 2113, name: 'Cheraia', nameAr: 'الشرايع' },
    { id: 2114, name: 'Collo', nameAr: 'القل' },
    { id: 2115, name: 'Djendel Saadi Mohamed', nameAr: 'جندل سعدي محمد' },
    { id: 2116, name: 'El Arrouch', nameAr: 'الحروش' },
    { id: 2117, name: 'El Ghedir', nameAr: 'الغدير' },
    { id: 2118, name: 'El Hadaiek', nameAr: 'الحدائق' },
    { id: 2119, name: 'El Marsa', nameAr: 'المرسى' },
    { id: 2120, name: 'Emjez Edchich', nameAr: 'مجاز الدشيش' },
    { id: 2121, name: 'Es Sebt', nameAr: 'السبت' },
    { id: 2122, name: 'Filfila', nameAr: 'فلفلة' },
    { id: 2123, name: 'Hammadi Krouma', nameAr: 'حمادي كرومة' },
    { id: 2124, name: 'Kanoua', nameAr: 'قنواع' },
    { id: 2125, name: 'Kerkara', nameAr: 'الكركرة' },
    { id: 2126, name: 'Khenag Maoune', nameAr: 'خناق مايو' },
    { id: 2127, name: 'Oued Zhour', nameAr: 'وادي الزهور' },
    { id: 2128, name: 'Ouldja Boulbalout', nameAr: 'الولجة بولبلوط' },
    { id: 2129, name: 'Ouled Attia', nameAr: 'أولاد عطية' },
    { id: 2130, name: 'Ouled Habbaba', nameAr: 'أولاد حبابة' },
    { id: 2131, name: 'Oum Toub', nameAr: 'أم الطوب' },
    { id: 2132, name: 'Ramdane Djamel', nameAr: 'رمضان جمال' },
    { id: 2133, name: 'Salah Bouchaour', nameAr: 'صالح بو الشعور' },
    { id: 2134, name: 'Sidi Mezghiche', nameAr: 'سيدي مزغيش' },
    { id: 2135, name: 'Skikda', nameAr: 'سكيكدة' },
    { id: 2136, name: 'Tamalous', nameAr: 'تمالوس' },
    { id: 2137, name: 'Zerdezas', nameAr: 'زردازة' },
    { id: 2138, name: 'Zitouna', nameAr: 'الزيتونة' },
  ],
  22: [
    { id: 2201, name: 'Ain El Berd', nameAr: 'عين البرد' },
    { id: 2202, name: 'Ain Kada', nameAr: 'عين قادة' },
    { id: 2203, name: 'Ain Thrid', nameAr: 'عين الثريد' },
    { id: 2204, name: 'Ain Tindamine', nameAr: 'عين تندمين' },
    { id: 2205, name: 'Ain- Adden', nameAr: 'عين أدن' },
    { id: 2206, name: 'Amarnas', nameAr: 'العمارنة' },
    { id: 2207, name: 'Bedrabine El Mokrani', nameAr: 'بضرابين المقراني' },
    { id: 2208, name: 'Belarbi', nameAr: 'بلعربي' },
    { id: 2209, name: 'Ben Badis', nameAr: 'بن باديس' },
    { id: 2210, name: 'Benachiba Chelia', nameAr: 'بن عشيبة شلية' },
    { id: 2211, name: 'Bir El Hammam', nameAr: 'بئر الحمام' },
    { id: 2212, name: 'Boudjebaa El Bordj', nameAr: 'بوجبهة البرج' },
    { id: 2213, name: 'Boukhanefis', nameAr: 'بوخنفيس' },
    { id: 2214, name: 'Chetouane Belaila', nameAr: 'شيطوان البلايلة' },
    { id: 2215, name: 'Dhaya', nameAr: 'الضاية' },
    { id: 2216, name: 'El Hacaiba', nameAr: 'الحصيبة' },
    { id: 2217, name: 'Hassi Dahou', nameAr: 'حاسي دحو' },
    { id: 2218, name: 'Hassi Zahana', nameAr: 'حاسي زهانة' },
    { id: 2219, name: 'Lamtar', nameAr: 'لمطار' },
    { id: 2220, name: 'M\'cid', nameAr: 'مسيد' },
    { id: 2221, name: 'Makedra', nameAr: 'مكدرة' },
    { id: 2222, name: 'Marhoum', nameAr: 'مرحوم' },
    { id: 2223, name: 'Merine', nameAr: 'مرين' },
    { id: 2224, name: 'Mezaourou', nameAr: 'مزاورو' },
    { id: 2225, name: 'Mostefa  Ben Brahim', nameAr: 'مصطفى بن ابراهيم' },
    { id: 2226, name: 'Moulay Slissen', nameAr: 'مولاي سليسن' },
    { id: 2227, name: 'Oued Sebaa', nameAr: 'وادي السبع' },
    { id: 2228, name: 'Oued Sefioun', nameAr: 'وادي سفيون' },
    { id: 2229, name: 'Oued Taourira', nameAr: 'وادي تاوريرة' },
    { id: 2230, name: 'Ras El Ma', nameAr: 'راس الماء' },
    { id: 2231, name: 'Redjem Demouche', nameAr: 'رجم دموش' },
    { id: 2232, name: 'Sehala Thaoura', nameAr: 'السهالة الثورة' },
    { id: 2233, name: 'Sfisef', nameAr: 'سفيزف' },
    { id: 2234, name: 'Sidi Ali Benyoub', nameAr: 'سيدي علي بن يوب' },
    { id: 2235, name: 'Sidi Ali Boussidi', nameAr: 'سيدي علي بوسيدي' },
    { id: 2236, name: 'Sidi Bel-Abbes', nameAr: 'سيدي بلعباس' },
    { id: 2237, name: 'Sidi Brahim', nameAr: 'سيدي ابراهيم' },
    { id: 2238, name: 'Sidi Chaib', nameAr: 'سيدي شعيب' },
    { id: 2239, name: 'Sidi Dahou Zairs', nameAr: 'سيدي دحو الزاير' },
    { id: 2240, name: 'Sidi Hamadouche', nameAr: 'سيدي حمادوش' },
    { id: 2241, name: 'Sidi Khaled', nameAr: 'سيدي خالد' },
    { id: 2242, name: 'Sidi Lahcene', nameAr: 'سيدي لحسن' },
    { id: 2243, name: 'Sidi Yacoub', nameAr: 'سيدي يعقوب' },
    { id: 2244, name: 'Tabia', nameAr: 'طابية' },
    { id: 2245, name: 'Taoudmout', nameAr: 'تاودموت' },
    { id: 2246, name: 'Tefessour', nameAr: 'تفسور' },
    { id: 2247, name: 'Teghalimet', nameAr: 'تغاليمت' },
    { id: 2248, name: 'Telagh', nameAr: 'تلاغ' },
    { id: 2249, name: 'Tenira', nameAr: 'تنيرة' },
    { id: 2250, name: 'Tessala', nameAr: 'تسالة' },
    { id: 2251, name: 'Tilmouni', nameAr: 'تلموني' },
    { id: 2252, name: 'Zerouala', nameAr: 'زروالة' },
  ],
  23: [
    { id: 2301, name: 'Ain El Berda', nameAr: 'عين الباردة' },
    { id: 2302, name: 'Annaba', nameAr: 'عنابة' },
    { id: 2303, name: 'Berrahal', nameAr: 'برحال' },
    { id: 2304, name: 'Chetaibi', nameAr: 'شطايبي' },
    { id: 2305, name: 'Cheurfa', nameAr: 'الشرفة' },
    { id: 2306, name: 'El Bouni', nameAr: 'البوني' },
    { id: 2307, name: 'El Eulma', nameAr: 'العلمة' },
    { id: 2308, name: 'El Hadjar', nameAr: 'الحجار' },
    { id: 2309, name: 'Oued El Aneb', nameAr: 'واد العنب' },
    { id: 2310, name: 'Seraidi', nameAr: 'سرايدي' },
    { id: 2311, name: 'Sidi Amar', nameAr: 'سيدي عمار' },
    { id: 2312, name: 'Treat', nameAr: 'التريعات' },
  ],
  24: [
    { id: 2401, name: 'Ain Ben Beida', nameAr: 'عين بن بيضاء' },
    { id: 2402, name: 'Ain Larbi', nameAr: 'عين العربي' },
    { id: 2403, name: 'Ain Makhlouf', nameAr: 'عين مخلوف' },
    { id: 2404, name: 'Ain Regada', nameAr: 'عين رقادة' },
    { id: 2405, name: 'Ain Sandel', nameAr: 'عين صندل' },
    { id: 2406, name: 'Belkheir', nameAr: 'بلخير' },
    { id: 2407, name: 'Bendjarah', nameAr: 'بن جراح' },
    { id: 2408, name: 'Beni Mezline', nameAr: 'بني مزلين' },
    { id: 2409, name: 'Bordj Sabath', nameAr: 'برج صباط' },
    { id: 2410, name: 'Bou Hachana', nameAr: 'بوحشانة' },
    { id: 2411, name: 'Bou Hamdane', nameAr: 'بوحمدان' },
    { id: 2412, name: 'Bouati Mahmoud', nameAr: 'بوعاتي محمود' },
    { id: 2413, name: 'Bouchegouf', nameAr: 'بوشقوف' },
    { id: 2414, name: 'Boumahra Ahmed', nameAr: 'بومهرة أحمد' },
    { id: 2415, name: 'Dahouara', nameAr: 'الدهوارة' },
    { id: 2416, name: 'Djeballah Khemissi', nameAr: 'جبالة الخميسي' },
    { id: 2417, name: 'El Fedjoudj', nameAr: 'الفجوج' },
    { id: 2418, name: 'Guelaat Bou Sbaa', nameAr: 'قلعة بوصبع' },
    { id: 2419, name: 'Guelma', nameAr: 'قالمة' },
    { id: 2420, name: 'Hammam Debagh', nameAr: 'حمام دباغ' },
    { id: 2421, name: 'Hammam N\'bail', nameAr: 'حمام النبايل' },
    { id: 2422, name: 'Heliopolis', nameAr: 'هيليوبوليس' },
    { id: 2423, name: 'Houari Boumedienne', nameAr: 'هواري بومدين' },
    { id: 2424, name: 'Khezaras', nameAr: 'لخزارة' },
    { id: 2425, name: 'Medjez Amar', nameAr: 'مجاز عمار' },
    { id: 2426, name: 'Medjez Sfa', nameAr: 'مجاز الصفاء' },
    { id: 2427, name: 'Nechmaya', nameAr: 'نشماية' },
    { id: 2428, name: 'Oued Cheham', nameAr: 'وادي الشحم' },
    { id: 2429, name: 'Oued Ferragha', nameAr: 'وادي فراغة' },
    { id: 2430, name: 'Oued Zenati', nameAr: 'وادي الزناتي' },
    { id: 2431, name: 'Ras El Agba', nameAr: 'رأس العقبة' },
    { id: 2432, name: 'Roknia', nameAr: 'الركنية' },
    { id: 2433, name: 'Sellaoua Announa', nameAr: 'سلاوة عنونة' },
    { id: 2434, name: 'Tamlouka', nameAr: 'تاملوكة' },
  ],
  25: [
    { id: 2501, name: 'Ain Abid', nameAr: 'عين عبيد' },
    { id: 2502, name: 'Ain Smara', nameAr: 'عين السمارة' },
    { id: 2503, name: 'Ben Badis', nameAr: 'أبن باديس الهرية' },
    { id: 2504, name: 'Beni Hamidane', nameAr: 'بني حميدان' },
    { id: 2505, name: 'Constantine', nameAr: 'قسنطينة' },
    { id: 2506, name: 'Didouche Mourad', nameAr: 'ديدوش مراد' },
    { id: 2507, name: 'El Khroub', nameAr: 'الخروب' },
    { id: 2508, name: 'Hamma Bouziane', nameAr: 'حامة بوزيان' },
    { id: 2509, name: 'Ibn Ziad', nameAr: 'ابن زياد' },
    { id: 2510, name: 'Messaoud Boudjeriou', nameAr: 'بوجريو مسعود' },
    { id: 2511, name: 'Ouled Rahmoun', nameAr: 'أولاد رحمون' },
    { id: 2512, name: 'Zighoud Youcef', nameAr: 'زيغود يوسف' },
  ],
  26: [
    { id: 2601, name: 'Ain Boucif', nameAr: 'عين بوسيف' },
    { id: 2602, name: 'Ain Ouksir', nameAr: 'عين اقصير' },
    { id: 2603, name: 'Aissaouia', nameAr: 'العيساوية' },
    { id: 2604, name: 'Aziz', nameAr: 'عزيز' },
    { id: 2605, name: 'Baata', nameAr: 'بعطة' },
    { id: 2606, name: 'Ben Chicao', nameAr: 'بن شكاو' },
    { id: 2607, name: 'Beni Slimane', nameAr: 'بني سليمان' },
    { id: 2608, name: 'Berrouaghia', nameAr: 'البرواقية' },
    { id: 2609, name: 'Bir Ben Laabed', nameAr: 'بئر بن عابد' },
    { id: 2610, name: 'Boghar', nameAr: 'بوغار' },
    { id: 2611, name: 'Bouaiche', nameAr: 'بوعيش' },
    { id: 2612, name: 'Bouaichoune', nameAr: 'بوعيشون' },
    { id: 2613, name: 'Bouchrahil', nameAr: 'بوشراحيل' },
    { id: 2614, name: 'Boughzoul', nameAr: 'بوغزول' },
    { id: 2615, name: 'Bouskene', nameAr: 'بوسكن' },
    { id: 2616, name: 'Chabounia', nameAr: 'الشهبونية' },
    { id: 2617, name: 'Chelalet El Adhaoura', nameAr: 'شلالة العذاورة' },
    { id: 2618, name: 'Cheniguel', nameAr: 'شنيقل' },
    { id: 2619, name: 'Derrag', nameAr: 'دراق' },
    { id: 2620, name: 'Djouab', nameAr: 'جواب' },
    { id: 2621, name: 'Draa Esmar', nameAr: 'ذراع السمار' },
    { id: 2622, name: 'El Azizia', nameAr: 'العزيزية' },
    { id: 2623, name: 'El Guelbelkebir', nameAr: 'القلب الكبير' },
    { id: 2624, name: 'El Hamdania', nameAr: 'الحمدانية' },
    { id: 2625, name: 'El Haoudane', nameAr: 'الحوضان' },
    { id: 2626, name: 'El Omaria', nameAr: 'العمارية' },
    { id: 2627, name: 'El Ouinet', nameAr: 'العوينات' },
    { id: 2628, name: 'Hannacha', nameAr: 'حناشة' },
    { id: 2629, name: 'Kef Lakhdar', nameAr: 'الكاف الاخضر' },
    { id: 2630, name: 'Khams Djouamaa', nameAr: 'خمس جوامع' },
    { id: 2631, name: 'Ksar El Boukhari', nameAr: 'قصر البخاري' },
    { id: 2632, name: 'M\'fatha', nameAr: 'مفاتحة' },
    { id: 2633, name: 'Maghraoua', nameAr: 'مغراوة' },
    { id: 2634, name: 'Medea', nameAr: 'المدية' },
    { id: 2635, name: 'Medjebar', nameAr: 'مجبر' },
    { id: 2636, name: 'Mezerana', nameAr: 'مزغنة' },
    { id: 2637, name: 'Mihoub', nameAr: 'ميهوب' },
    { id: 2638, name: 'Ouamri', nameAr: 'عوامري' },
    { id: 2639, name: 'Oued Harbil', nameAr: 'وادي حربيل' },
    { id: 2640, name: 'Ouled Antar', nameAr: 'أولاد عنتر' },
    { id: 2641, name: 'Ouled Bouachra', nameAr: 'أولاد بوعشرة' },
    { id: 2642, name: 'Ouled Brahim', nameAr: 'أولاد إبراهيم' },
    { id: 2643, name: 'Ouled Deid', nameAr: 'أولاد دايد' },
    { id: 2644, name: 'Ouled Emaaraf', nameAr: 'أولاد امعرف' },
    { id: 2645, name: 'Ouled Hellal', nameAr: 'أولاد هلال' },
    { id: 2646, name: 'Oum El Djellil', nameAr: 'أم الجليل' },
    { id: 2647, name: 'Ouzera', nameAr: 'وزرة' },
    { id: 2648, name: 'Rebaia', nameAr: 'الربعية' },
    { id: 2649, name: 'Saneg', nameAr: 'السانق' },
    { id: 2650, name: 'Sedraya', nameAr: 'سدراية' },
    { id: 2651, name: 'Seghouane', nameAr: 'سغوان' },
    { id: 2652, name: 'Si Mahdjoub', nameAr: 'سي المحجوب' },
    { id: 2653, name: 'Sidi Demed', nameAr: 'سيدي دامد' },
    { id: 2654, name: 'Sidi Naamane', nameAr: 'سيدي نعمان' },
    { id: 2655, name: 'Sidi Rabie', nameAr: 'سيدي الربيع' },
    { id: 2656, name: 'Sidi Zahar', nameAr: 'سيدي زهار' },
    { id: 2657, name: 'Sidi Ziane', nameAr: 'سيدي زيان' },
    { id: 2658, name: 'Souagui', nameAr: 'السواقي' },
    { id: 2659, name: 'Tablat', nameAr: 'تابلاط' },
    { id: 2660, name: 'Tafraout', nameAr: 'تفراوت' },
    { id: 2661, name: 'Tamesguida', nameAr: 'تمسقيدة' },
    { id: 2662, name: 'Tizi Mahdi', nameAr: 'تيزي مهدي' },
    { id: 2663, name: 'Tletat Ed Douair', nameAr: 'ثلاث دوائر' },
    { id: 2664, name: 'Zoubiria', nameAr: 'الزبيرية' },
  ],
  27: [
    { id: 2701, name: 'Achaacha', nameAr: 'عشعاشة' },
    { id: 2702, name: 'Ain-Boudinar', nameAr: 'عين بودينار' },
    { id: 2703, name: 'Ain-Nouissy', nameAr: 'عين نويسي' },
    { id: 2704, name: 'Ain-Sidi Cherif', nameAr: 'عين سيدي الشريف' },
    { id: 2705, name: 'Ain-Tedles', nameAr: 'عين تادلس' },
    { id: 2706, name: 'Benabdelmalek Ramdane', nameAr: 'بن عبد المالك رمضان' },
    { id: 2707, name: 'Bouguirat', nameAr: 'بوقيراط' },
    { id: 2708, name: 'Fornaka', nameAr: 'فرناقة' },
    { id: 2709, name: 'Hadjadj', nameAr: 'حجاج' },
    { id: 2710, name: 'Hassi Mameche', nameAr: 'حاسي ماماش' },
    { id: 2711, name: 'Hassiane', nameAr: 'الحسيان (بني ياحي' },
    { id: 2712, name: 'Khadra', nameAr: 'خضرة' },
    { id: 2713, name: 'Kheir-Eddine', nameAr: 'خير الدين' },
    { id: 2714, name: 'Mansourah', nameAr: 'منصورة' },
    { id: 2715, name: 'Mazagran', nameAr: 'مزغران' },
    { id: 2716, name: 'Mesra', nameAr: 'ماسرة' },
    { id: 2717, name: 'Mostaganem', nameAr: 'مستغانم' },
    { id: 2718, name: 'Nekmaria', nameAr: 'نكمارية' },
    { id: 2719, name: 'Oued El Kheir', nameAr: 'وادي الخير' },
    { id: 2720, name: 'Ouled Boughalem', nameAr: 'أولاد بوغالم' },
    { id: 2721, name: 'Ouled-Maalah', nameAr: 'أولاد مع الله' },
    { id: 2722, name: 'Safsaf', nameAr: 'صفصاف' },
    { id: 2723, name: 'Sayada', nameAr: 'صيادة' },
    { id: 2724, name: 'Sidi Ali', nameAr: 'سيدي علي' },
    { id: 2725, name: 'Sidi Belaattar', nameAr: 'سيدي بلعطار' },
    { id: 2726, name: 'Sidi-Lakhdar', nameAr: 'سيدي لخضر' },
    { id: 2727, name: 'Sirat', nameAr: 'سيرات' },
    { id: 2728, name: 'Souaflia', nameAr: 'السوافلية' },
    { id: 2729, name: 'Sour', nameAr: 'سور' },
    { id: 2730, name: 'Stidia', nameAr: 'ستيدية' },
    { id: 2731, name: 'Tazgait', nameAr: 'تزقايت' },
    { id: 2732, name: 'Touahria', nameAr: 'الطواهرية' },
  ],
  28: [
    { id: 2801, name: 'Ain El Hadjel', nameAr: 'عين الحجل' },
    { id: 2802, name: 'Ain El Melh', nameAr: 'عين الملح' },
    { id: 2803, name: 'Ain Fares', nameAr: 'عين فارس' },
    { id: 2804, name: 'Ain Khadra', nameAr: 'عين الخضراء' },
    { id: 2805, name: 'Ain Rich', nameAr: 'عين الريش' },
    { id: 2806, name: 'Belaiba', nameAr: 'بلعايبة' },
    { id: 2807, name: 'Ben Srour', nameAr: 'بن سرور' },
    { id: 2808, name: 'Beni Ilmane', nameAr: 'بني يلمان' },
    { id: 2809, name: 'Benzouh', nameAr: 'بن زوه' },
    { id: 2810, name: 'Berhoum', nameAr: 'برهوم' },
    { id: 2811, name: 'Bir Foda', nameAr: 'بئر فضة' },
    { id: 2812, name: 'Bou Saada', nameAr: 'بوسعادة' },
    { id: 2813, name: 'Bouti Sayeh', nameAr: 'بوطي السايح' },
    { id: 2814, name: 'Chellal', nameAr: 'شلال' },
    { id: 2815, name: 'Dehahna', nameAr: 'دهاهنة' },
    { id: 2816, name: 'Djebel Messaad', nameAr: 'جبل مساعد' },
    { id: 2817, name: 'El Hamel', nameAr: 'الهامل' },
    { id: 2818, name: 'El Houamed', nameAr: 'الحوامد' },
    { id: 2819, name: 'Hammam Dalaa', nameAr: 'حمام الضلعة' },
    { id: 2820, name: 'Khettouti Sed-El-Jir', nameAr: 'خطوطي سد الجير' },
    { id: 2821, name: 'Khoubana', nameAr: 'خبانة' },
    { id: 2822, name: 'M\'cif', nameAr: 'مسيف' },
    { id: 2823, name: 'M\'sila', nameAr: 'المسيلة' },
    { id: 2824, name: 'M\'tarfa', nameAr: 'المطارفة' },
    { id: 2825, name: 'Maadid', nameAr: 'المعاضيد' },
    { id: 2826, name: 'Maarif', nameAr: 'معاريف' },
    { id: 2827, name: 'Magra', nameAr: 'مقرة' },
    { id: 2828, name: 'Medjedel', nameAr: 'امجدل' },
    { id: 2829, name: 'Menaa', nameAr: 'مناعة' },
    { id: 2830, name: 'Mohamed Boudiaf', nameAr: 'محمد بوضياف' },
    { id: 2831, name: 'Ouanougha', nameAr: 'ونوغة' },
    { id: 2832, name: 'Ouled Addi Guebala', nameAr: 'أولاد عدي لقبالة' },
    { id: 2833, name: 'Ouled Derradj', nameAr: 'أولاد دراج' },
    { id: 2834, name: 'Ouled Madhi', nameAr: 'أولاد ماضي' },
    { id: 2835, name: 'Ouled Mansour', nameAr: 'أولاد منصور' },
    { id: 2836, name: 'Ouled Sidi Brahim', nameAr: 'أولاد سيدي ابراهيم' },
    { id: 2837, name: 'Ouled Slimane', nameAr: 'أولاد سليمان' },
    { id: 2838, name: 'Oulteme', nameAr: 'ولتام' },
    { id: 2839, name: 'Sidi Aissa', nameAr: 'سيدي عيسى' },
    { id: 2840, name: 'Sidi Ameur', nameAr: 'سيدي عامر' },
    { id: 2841, name: 'Sidi Hadjeres', nameAr: 'سيدي هجرس' },
    { id: 2842, name: 'Sidi M\'hamed', nameAr: 'سيدي امحمد' },
    { id: 2843, name: 'Slim', nameAr: 'سليم' },
    { id: 2844, name: 'Souamaa', nameAr: 'السوامع' },
    { id: 2845, name: 'Tamsa', nameAr: 'تامسة' },
    { id: 2846, name: 'Tarmount', nameAr: 'تارمونت' },
    { id: 2847, name: 'Zarzour', nameAr: 'زرزور' },
  ],
  29: [
    { id: 2901, name: 'Ain Fares', nameAr: 'عين فارس' },
    { id: 2902, name: 'Ain Fekan', nameAr: 'عين فكان' },
    { id: 2903, name: 'Ain Ferah', nameAr: 'عين فراح' },
    { id: 2904, name: 'Ain Frass', nameAr: 'عين أفرص' },
    { id: 2905, name: 'Alaimia', nameAr: 'العلايمية' },
    { id: 2906, name: 'Aouf', nameAr: 'عوف' },
    { id: 2907, name: 'Benian', nameAr: 'بنيان' },
    { id: 2908, name: 'Bou Henni', nameAr: 'بوهني' },
    { id: 2909, name: 'Bouhanifia', nameAr: 'بوحنيفية' },
    { id: 2910, name: 'Chorfa', nameAr: 'الشرفاء' },
    { id: 2911, name: 'El Bordj', nameAr: 'البرج' },
    { id: 2912, name: 'El Gaada', nameAr: 'القعدة' },
    { id: 2913, name: 'El Ghomri', nameAr: 'الغمري' },
    { id: 2914, name: 'El Gueitena', nameAr: 'القطنة' },
    { id: 2915, name: 'El Hachem', nameAr: 'الحشم' },
    { id: 2916, name: 'El Keurt', nameAr: 'القرط' },
    { id: 2917, name: 'El Mamounia', nameAr: 'المأمونية' },
    { id: 2918, name: 'El Menaouer', nameAr: 'المنور' },
    { id: 2919, name: 'Ferraguig', nameAr: 'فراقيق' },
    { id: 2920, name: 'Froha', nameAr: 'فروحة' },
    { id: 2921, name: 'Gharrous', nameAr: 'غروس' },
    { id: 2922, name: 'Ghriss', nameAr: 'غريس' },
    { id: 2923, name: 'Guerdjoum', nameAr: 'قرجوم' },
    { id: 2924, name: 'Hacine', nameAr: 'حسين' },
    { id: 2925, name: 'Khalouia', nameAr: 'خلوية' },
    { id: 2926, name: 'Makhda', nameAr: 'ماقضة' },
    { id: 2927, name: 'Maoussa', nameAr: 'ماوسة' },
    { id: 2928, name: 'Mascara', nameAr: 'معسكر' },
    { id: 2929, name: 'Matemore', nameAr: 'المطمور' },
    { id: 2930, name: 'Mocta-Douz', nameAr: 'مقطع الدوز' },
    { id: 2931, name: 'Mohammadia', nameAr: 'المحمدية' },
    { id: 2932, name: 'Nesmot', nameAr: 'نسمط' },
    { id: 2933, name: 'Oggaz', nameAr: 'عقاز' },
    { id: 2934, name: 'Oued El Abtal', nameAr: 'وادي الأبطال' },
    { id: 2935, name: 'Oued Taria', nameAr: 'وادي التاغية' },
    { id: 2936, name: 'Ras El Ain Amirouche', nameAr: 'رأس عين عميروش' },
    { id: 2937, name: 'Sedjerara', nameAr: 'سجرارة' },
    { id: 2938, name: 'Sehailia', nameAr: 'السهايلية' },
    { id: 2939, name: 'Sidi Abdeldjebar', nameAr: 'سيدي عبد الجبار' },
    { id: 2940, name: 'Sidi Abdelmoumene', nameAr: 'سيدي عبد المومن' },
    { id: 2941, name: 'Sidi Boussaid', nameAr: 'سيدي بوسعيد' },
    { id: 2942, name: 'Sidi Kada', nameAr: 'سيدي قادة' },
    { id: 2943, name: 'Sig', nameAr: 'سيق' },
    { id: 2944, name: 'Tighennif', nameAr: 'تيغنيف' },
    { id: 2945, name: 'Tizi', nameAr: 'تيزي' },
    { id: 2946, name: 'Zahana', nameAr: 'زهانة' },
    { id: 2947, name: 'Zelamta', nameAr: 'زلامطة' },
  ],
  30: [
    { id: 3001, name: 'Ain Beida', nameAr: 'عين البيضاء' },
    { id: 3002, name: 'El Borma', nameAr: 'البرمة' },
    { id: 3003, name: 'Hassi Ben Abdellah', nameAr: 'حاسي بن عبد الله' },
    { id: 3004, name: 'Hassi Messaoud', nameAr: 'حاسي مسعود' },
    { id: 3005, name: 'N\'goussa', nameAr: 'انقوسة' },
    { id: 3006, name: 'Ouargla', nameAr: 'ورقلة' },
    { id: 3007, name: 'Rouissat', nameAr: 'الرويسات' },
    { id: 3008, name: 'Sidi Khouiled', nameAr: 'سيدي خويلد' },
  ],
  31: [
    { id: 3101, name: 'Ain Biya', nameAr: 'عين البية' },
    { id: 3102, name: 'Ain Kerma', nameAr: 'عين الكرمة' },
    { id: 3103, name: 'Ain Turk', nameAr: 'عين الترك' },
    { id: 3104, name: 'Arzew', nameAr: 'أرزيو' },
    { id: 3105, name: 'Ben Freha', nameAr: 'بن فريحة' },
    { id: 3106, name: 'Bethioua', nameAr: 'بطيوة' },
    { id: 3107, name: 'Bir El Djir', nameAr: 'بئر الجير' },
    { id: 3108, name: 'Boufatis', nameAr: 'بوفاتيس' },
    { id: 3109, name: 'Bousfer', nameAr: 'بوسفر' },
    { id: 3110, name: 'Boutlelis', nameAr: 'بوتليليس' },
    { id: 3111, name: 'El Ancor', nameAr: 'العنصر' },
    { id: 3112, name: 'El Braya', nameAr: 'البراية' },
    { id: 3113, name: 'El Kerma', nameAr: 'الكرمة' },
    { id: 3114, name: 'Es Senia', nameAr: 'السانية' },
    { id: 3115, name: 'Gdyel', nameAr: 'قديل' },
    { id: 3116, name: 'Hassi Ben Okba', nameAr: 'حاسي بن عقبة' },
    { id: 3117, name: 'Hassi Bounif', nameAr: 'حاسي بونيف' },
    { id: 3118, name: 'Hassi Mefsoukh', nameAr: 'حاسي مفسوخ' },
    { id: 3119, name: 'Marsat El Hadjadj', nameAr: 'مرسى الحجاج' },
    { id: 3120, name: 'Mers El Kebir', nameAr: 'المرسى الكبير' },
    { id: 3121, name: 'Messerghin', nameAr: 'مسرغين' },
    { id: 3122, name: 'Oran', nameAr: 'وهران' },
    { id: 3123, name: 'Oued Tlelat', nameAr: 'وادي تليلات' },
    { id: 3124, name: 'Sidi Ben Yebka', nameAr: 'سيدي بن يبقى' },
    { id: 3125, name: 'Sidi Chami', nameAr: 'سيدي الشحمي' },
    { id: 3126, name: 'Tafraoui', nameAr: 'طفراوي' },
  ],
  32: [
    { id: 3201, name: 'Ain El Orak', nameAr: 'عين العراك' },
    { id: 3202, name: 'Arbaouat', nameAr: 'اربوات' },
    { id: 3203, name: 'Boualem', nameAr: 'بوعلام' },
    { id: 3204, name: 'Bougtoub', nameAr: 'بوقطب' },
    { id: 3205, name: 'Boussemghoun', nameAr: 'بوسمغون' },
    { id: 3206, name: 'Brezina', nameAr: 'بريزينة' },
    { id: 3207, name: 'Cheguig', nameAr: 'الشقيق' },
    { id: 3208, name: 'Chellala', nameAr: 'شلالة' },
    { id: 3209, name: 'El Bayadh', nameAr: 'البيض' },
    { id: 3210, name: 'El Bnoud', nameAr: 'البنود' },
    { id: 3211, name: 'El Kheiter', nameAr: 'الخيثر' },
    { id: 3212, name: 'El Mehara', nameAr: 'المحرة' },
    { id: 3213, name: 'Ghassoul', nameAr: 'الغاسول' },
    { id: 3214, name: 'Kef El Ahmar', nameAr: 'الكاف الأحمر' },
    { id: 3215, name: 'Krakda', nameAr: 'كراكدة' },
    { id: 3216, name: 'Labiodh Sidi Cheikh', nameAr: 'الأبيض سيدي الشيخ' },
    { id: 3217, name: 'Rogassa', nameAr: 'رقاصة' },
    { id: 3218, name: 'Sidi Ameur', nameAr: 'سيدي عامر' },
    { id: 3219, name: 'Sidi Slimane', nameAr: 'سيدي سليمان' },
    { id: 3220, name: 'Sidi Tiffour', nameAr: 'سيدي طيفور' },
    { id: 3221, name: 'Stitten', nameAr: 'ستيتن' },
    { id: 3222, name: 'Tousmouline', nameAr: 'توسمولين' },
  ],
  33: [
    { id: 3301, name: 'Bordj Omar Driss', nameAr: 'برج عمر إدريس' },
    { id: 3302, name: 'Debdeb', nameAr: 'دبداب' },
    { id: 3303, name: 'Illizi', nameAr: 'إيليزي' },
    { id: 3304, name: 'In Amenas', nameAr: 'إن أمناس' },
  ],
  34: [
    { id: 3401, name: 'Ain Taghrout', nameAr: 'عين تاغروت' },
    { id: 3402, name: 'Ain Tesra', nameAr: 'عين تسرة' },
    { id: 3403, name: 'B. B. Arreridj', nameAr: 'برج بوعريرج' },
    { id: 3404, name: 'Belimour', nameAr: 'بليمور' },
    { id: 3405, name: 'Ben Daoud', nameAr: 'بن داود' },
    { id: 3406, name: 'Bir Kasdali', nameAr: 'بئر قاصد علي' },
    { id: 3407, name: 'Bordj Ghedir', nameAr: 'برج الغدير' },
    { id: 3408, name: 'Bordj Zemmoura', nameAr: 'برج زمورة' },
    { id: 3409, name: 'Colla', nameAr: 'القلة' },
    { id: 3410, name: 'Djaafra', nameAr: 'جعافرة' },
    { id: 3411, name: 'El Achir', nameAr: 'الياشير' },
    { id: 3412, name: 'El Annasseur', nameAr: 'العناصر' },
    { id: 3413, name: 'El Euch', nameAr: 'العش' },
    { id: 3414, name: 'El M\'hir', nameAr: 'المهير' },
    { id: 3415, name: 'El Main', nameAr: 'الماين' },
    { id: 3416, name: 'Elhammadia', nameAr: 'الحمادية' },
    { id: 3417, name: 'Ghailasa', nameAr: 'غيلاسة' },
    { id: 3418, name: 'Haraza', nameAr: 'حرازة' },
    { id: 3419, name: 'Hasnaoua', nameAr: 'حسناوة' },
    { id: 3420, name: 'Khelil', nameAr: 'خليل' },
    { id: 3421, name: 'Ksour', nameAr: 'القصور' },
    { id: 3422, name: 'Mansoura', nameAr: 'المنصورة' },
    { id: 3423, name: 'Medjana', nameAr: 'مجانة' },
    { id: 3424, name: 'Ouled Brahem', nameAr: 'أولاد أبراهم' },
    { id: 3425, name: 'Ouled Dahmane', nameAr: 'أولاد دحمان' },
    { id: 3426, name: 'Ouled Sidi-Brahim', nameAr: 'أولاد سيدي ابراهيم' },
    { id: 3427, name: 'Rabta', nameAr: 'الرابطة' },
    { id: 3428, name: 'Ras El Oued', nameAr: 'رأس الوادي' },
    { id: 3429, name: 'Sidi-Embarek', nameAr: 'سيدي أمبارك' },
    { id: 3430, name: 'Taglait', nameAr: 'تقلعيت' },
    { id: 3431, name: 'Tassamert', nameAr: 'تسامرت' },
    { id: 3432, name: 'Tefreg', nameAr: 'تفرق' },
    { id: 3433, name: 'Teniet En Nasr', nameAr: 'ثنية النصر' },
    { id: 3434, name: 'Tixter', nameAr: 'تيكستار' },
  ],
  35: [
    { id: 3501, name: 'Afir', nameAr: 'أعفير' },
    { id: 3502, name: 'Ammal', nameAr: 'عمال' },
    { id: 3503, name: 'Baghlia', nameAr: 'بغلية' },
    { id: 3504, name: 'Ben Choud', nameAr: 'بن شود' },
    { id: 3505, name: 'Beni Amrane', nameAr: 'بني عمران' },
    { id: 3506, name: 'Bordj Menaiel', nameAr: 'برج منايل' },
    { id: 3507, name: 'Boudouaou', nameAr: 'بودواو' },
    { id: 3508, name: 'Boudouaou El Bahri', nameAr: 'بودواو البحري' },
    { id: 3509, name: 'Boumerdes', nameAr: 'بومرداس' },
    { id: 3510, name: 'Bouzegza Keddara', nameAr: 'بوزقزة قدارة' },
    { id: 3511, name: 'Chabet El Ameur', nameAr: 'شعبة العامر' },
    { id: 3512, name: 'Corso', nameAr: 'قورصو' },
    { id: 3513, name: 'Dellys', nameAr: 'دلس' },
    { id: 3514, name: 'Djinet', nameAr: 'جنات' },
    { id: 3515, name: 'El Kharrouba', nameAr: 'الخروبة' },
    { id: 3516, name: 'Hammedi', nameAr: 'حمادي' },
    { id: 3517, name: 'Isser', nameAr: 'يسر' },
    { id: 3518, name: 'Khemis El Khechna', nameAr: 'خميس الخشنة' },
    { id: 3519, name: 'Larbatache', nameAr: 'الاربعطاش' },
    { id: 3520, name: 'Leghata', nameAr: 'لقاطة' },
    { id: 3521, name: 'Naciria', nameAr: 'الناصرية' },
    { id: 3522, name: 'Ouled Aissa', nameAr: 'أولاد عيسى' },
    { id: 3523, name: 'Ouled Hedadj', nameAr: 'أولاد هداج' },
    { id: 3524, name: 'Ouled Moussa', nameAr: 'أولاد موسى' },
    { id: 3525, name: 'Si Mustapha', nameAr: 'سي مصطفى' },
    { id: 3526, name: 'Sidi Daoud', nameAr: 'سيدي داود' },
    { id: 3527, name: 'Souk El Had', nameAr: 'سوق الحد' },
    { id: 3528, name: 'Taourga', nameAr: 'تاورقة' },
    { id: 3529, name: 'Thenia', nameAr: 'الثنية' },
    { id: 3530, name: 'Tidjelabine', nameAr: 'تيجلابين' },
    { id: 3531, name: 'Timezrit', nameAr: 'تيمزريت' },
    { id: 3532, name: 'Zemmouri', nameAr: 'زموري' },
  ],
  36: [
    { id: 3601, name: 'Ain El Assel', nameAr: 'عين العسل' },
    { id: 3602, name: 'Ain Kerma', nameAr: 'عين الكرمة' },
    { id: 3603, name: 'Asfour', nameAr: 'عصفور' },
    { id: 3604, name: 'Ben M Hidi', nameAr: 'بن مهيدي' },
    { id: 3605, name: 'Berrihane', nameAr: 'بريحان' },
    { id: 3606, name: 'Besbes', nameAr: 'البسباس' },
    { id: 3607, name: 'Bougous', nameAr: 'بوقوس' },
    { id: 3608, name: 'Bouhadjar', nameAr: 'بوحجار' },
    { id: 3609, name: 'Bouteldja', nameAr: 'بوثلجة' },
    { id: 3610, name: 'Chebaita Mokhtar', nameAr: 'شبيطة مختار' },
    { id: 3611, name: 'Chefia', nameAr: 'الشافية' },
    { id: 3612, name: 'Chihani', nameAr: 'شحاني' },
    { id: 3613, name: 'Drean', nameAr: 'الذرعـان' },
    { id: 3614, name: 'Echatt', nameAr: 'الشط' },
    { id: 3615, name: 'El Aioun', nameAr: 'العيون' },
    { id: 3616, name: 'El Kala', nameAr: 'القالة' },
    { id: 3617, name: 'El Tarf', nameAr: 'الطارف' },
    { id: 3618, name: 'Hammam Beni Salah', nameAr: 'حمام بني صالح' },
    { id: 3619, name: 'Lac Des Oiseaux', nameAr: 'بحيرة الطيور' },
    { id: 3620, name: 'Oued Zitoun', nameAr: 'وادي الزيتون' },
    { id: 3621, name: 'Raml Souk', nameAr: 'رمل السوق' },
    { id: 3622, name: 'Souarekh', nameAr: 'السوارخ' },
    { id: 3623, name: 'Zerizer', nameAr: 'زريزر' },
    { id: 3624, name: 'Zitouna', nameAr: 'الزيتونة' },
  ],
  37: [
    { id: 3701, name: 'Oum El Assel', nameAr: 'أم العسل' },
    { id: 3702, name: 'Tindouf', nameAr: 'تندوف' },
  ],
  38: [
    { id: 3801, name: 'Ammari', nameAr: 'عماري' },
    { id: 3802, name: 'Beni Chaib', nameAr: 'بني شعيب' },
    { id: 3803, name: 'Beni Lahcene', nameAr: 'بني لحسن' },
    { id: 3804, name: 'Bordj Bounaama', nameAr: 'برج بونعامة' },
    { id: 3805, name: 'Bordj El Emir Abdelkader', nameAr: 'برج الأمير عبد القادر' },
    { id: 3806, name: 'Boucaid', nameAr: 'بوقائد' },
    { id: 3807, name: 'Khemisti', nameAr: 'خميستي' },
    { id: 3808, name: 'Larbaa', nameAr: 'الأربعاء' },
    { id: 3809, name: 'Lardjem', nameAr: 'لرجام' },
    { id: 3810, name: 'Layoune', nameAr: 'العيون' },
    { id: 3811, name: 'Lazharia', nameAr: 'الأزهرية' },
    { id: 3812, name: 'Maacem', nameAr: 'المعاصم' },
    { id: 3813, name: 'Melaab', nameAr: 'الملعب' },
    { id: 3814, name: 'Ouled Bessam', nameAr: 'أولاد بسام' },
    { id: 3815, name: 'Sidi Abed', nameAr: 'سيدي عابد' },
    { id: 3816, name: 'Sidi Boutouchent', nameAr: 'سيدي بوتوشنت' },
    { id: 3817, name: 'Sidi Lantri', nameAr: 'سيدي العنتري' },
    { id: 3818, name: 'Sidi Slimane', nameAr: 'سيدي سليمان' },
    { id: 3819, name: 'Tamellahet', nameAr: 'تملاحت' },
    { id: 3820, name: 'Theniet El Had', nameAr: 'ثنية الاحد' },
    { id: 3821, name: 'Tissemsilt', nameAr: 'تيسمسيلت' },
    { id: 3822, name: 'Youssoufia', nameAr: 'اليوسفية' },
  ],
  39: [
    { id: 3901, name: 'Bayadha', nameAr: 'البياضة' },
    { id: 3902, name: 'Ben Guecha', nameAr: 'بن  قشة' },
    { id: 3903, name: 'Debila', nameAr: 'الدبيلة' },
    { id: 3904, name: 'Douar El Maa', nameAr: 'دوار الماء' },
    { id: 3905, name: 'El Ogla', nameAr: 'العقلة' },
    { id: 3906, name: 'El-Oued', nameAr: 'الوادي' },
    { id: 3907, name: 'Guemar', nameAr: 'قمار' },
    { id: 3908, name: 'Hamraia', nameAr: 'الحمراية' },
    { id: 3909, name: 'Hassani Abdelkrim', nameAr: 'حساني عبد الكريم' },
    { id: 3910, name: 'Hassi Khalifa', nameAr: 'حاسي خليفة' },
    { id: 3911, name: 'Kouinine', nameAr: 'كوينين' },
    { id: 3912, name: 'Magrane', nameAr: 'المقرن' },
    { id: 3913, name: 'Mih Ouansa', nameAr: 'اميه وانسة' },
    { id: 3914, name: 'Nakhla', nameAr: 'النخلة' },
    { id: 3915, name: 'Oued El Alenda', nameAr: 'وادي العلندة' },
    { id: 3916, name: 'Ourmes', nameAr: 'ورماس' },
    { id: 3917, name: 'Reguiba', nameAr: 'الرقيبة' },
    { id: 3918, name: 'Robbah', nameAr: 'الرباح' },
    { id: 3919, name: 'Sidi Aoun', nameAr: 'سيدي عون' },
    { id: 3920, name: 'Taghzout', nameAr: 'تغزوت' },
    { id: 3921, name: 'Taleb Larbi', nameAr: 'الطالب العربي' },
    { id: 3922, name: 'Trifaoui', nameAr: 'الطريفاوي' },
  ],
  40: [
    { id: 4001, name: 'Ain Touila', nameAr: 'عين الطويلة' },
    { id: 4002, name: 'Babar', nameAr: 'بابار' },
    { id: 4003, name: 'Baghai', nameAr: 'بغاي' },
    { id: 4004, name: 'Bouhmama', nameAr: 'بوحمامة' },
    { id: 4005, name: 'Chechar', nameAr: 'ششار' },
    { id: 4006, name: 'Chelia', nameAr: 'شلية' },
    { id: 4007, name: 'Djellal', nameAr: 'جلال' },
    { id: 4008, name: 'El Hamma', nameAr: 'الحامة' },
    { id: 4009, name: 'El Mahmal', nameAr: 'المحمل' },
    { id: 4010, name: 'El Oueldja', nameAr: 'الولجة' },
    { id: 4011, name: 'Ensigha', nameAr: 'انسيغة' },
    { id: 4012, name: 'Kais', nameAr: 'قايس' },
    { id: 4013, name: 'Khenchela', nameAr: 'خنشلة' },
    { id: 4014, name: 'Khirane', nameAr: 'خيران' },
    { id: 4015, name: 'M\'sara', nameAr: 'مصارة' },
    { id: 4016, name: 'M\'toussa', nameAr: 'متوسة' },
    { id: 4017, name: 'Ouled Rechache', nameAr: 'أولاد رشاش' },
    { id: 4018, name: 'Remila', nameAr: 'الرميلة' },
    { id: 4019, name: 'Tamza', nameAr: 'طامزة' },
    { id: 4020, name: 'Taouzianat', nameAr: 'تاوزيانت' },
    { id: 4021, name: 'Yabous', nameAr: 'يابوس' },
  ],
  41: [
    { id: 4101, name: 'Ain Soltane', nameAr: 'عين سلطان' },
    { id: 4102, name: 'Ain Zana', nameAr: 'عين الزانة' },
    { id: 4103, name: 'Bir Bouhouche', nameAr: 'بئر بوحوش' },
    { id: 4104, name: 'Drea', nameAr: 'الدريعة' },
    { id: 4105, name: 'Haddada', nameAr: 'الحدادة' },
    { id: 4106, name: 'Hanencha', nameAr: 'الحنانشة' },
    { id: 4107, name: 'Khedara', nameAr: 'الخضارة' },
    { id: 4108, name: 'Khemissa', nameAr: 'خميسة' },
    { id: 4109, name: 'M\'daourouche', nameAr: 'مداوروش' },
    { id: 4110, name: 'Machroha', nameAr: 'المشروحة' },
    { id: 4111, name: 'Merahna', nameAr: 'المراهنة' },
    { id: 4112, name: 'Oued Kebrit', nameAr: 'وادي الكبريت' },
    { id: 4113, name: 'Ouillen', nameAr: 'ويلان' },
    { id: 4114, name: 'Ouled Driss', nameAr: 'أولاد إدريس' },
    { id: 4115, name: 'Ouled Moumen', nameAr: 'أولاد مومن' },
    { id: 4116, name: 'Oum El Adhaim', nameAr: 'أم العظايم' },
    { id: 4117, name: 'Ragouba', nameAr: 'الراقوبة' },
    { id: 4118, name: 'Safel El Ouiden', nameAr: 'سافل الويدان' },
    { id: 4119, name: 'Sedrata', nameAr: 'سدراتة' },
    { id: 4120, name: 'Sidi Fredj', nameAr: 'سيدي فرج' },
    { id: 4121, name: 'Souk Ahras', nameAr: 'سوق أهراس' },
    { id: 4122, name: 'Taoura', nameAr: 'تاورة' },
    { id: 4123, name: 'Terraguelt', nameAr: 'ترقالت' },
    { id: 4124, name: 'Tiffech', nameAr: 'تيفاش' },
    { id: 4125, name: 'Zaarouria', nameAr: 'الزعرورية' },
    { id: 4126, name: 'Zouabi', nameAr: 'الزوابي' },
  ],
  42: [
    { id: 4201, name: 'Aghbal', nameAr: 'أغبال' },
    { id: 4202, name: 'Ahmer El Ain', nameAr: 'أحمر العين' },
    { id: 4203, name: 'Ain Tagourait', nameAr: 'عين تاقورايت' },
    { id: 4204, name: 'Attatba', nameAr: 'الحطاطبة' },
    { id: 4205, name: 'Beni Mileuk', nameAr: 'بني ميلك' },
    { id: 4206, name: 'Bou Haroun', nameAr: 'بوهارون' },
    { id: 4207, name: 'Bou Ismail', nameAr: 'بواسماعيل' },
    { id: 4208, name: 'Bourkika', nameAr: 'بورقيقة' },
    { id: 4209, name: 'Chaiba', nameAr: 'الشعيبة' },
    { id: 4210, name: 'Cherchell', nameAr: 'شرشال' },
    { id: 4211, name: 'Damous', nameAr: 'الداموس' },
    { id: 4212, name: 'Douaouda', nameAr: 'دواودة' },
    { id: 4213, name: 'Fouka', nameAr: 'فوكة' },
    { id: 4214, name: 'Gouraya', nameAr: 'قوراية' },
    { id: 4215, name: 'Hadjout', nameAr: 'حجوط' },
    { id: 4216, name: 'Hadjret Ennous', nameAr: 'حجرة النص' },
    { id: 4217, name: 'Khemisti', nameAr: 'خميستي' },
    { id: 4218, name: 'Kolea', nameAr: 'القليعة' },
    { id: 4219, name: 'Larhat', nameAr: 'الأرهاط' },
    { id: 4220, name: 'Menaceur', nameAr: 'مناصر' },
    { id: 4221, name: 'Merad', nameAr: 'مراد' },
    { id: 4222, name: 'Messelmoun', nameAr: 'مسلمون' },
    { id: 4223, name: 'Nador', nameAr: 'الناظور' },
    { id: 4224, name: 'Sidi Ghiles', nameAr: 'سيدي غيلاس' },
    { id: 4225, name: 'Sidi Rached', nameAr: 'سيدي راشد' },
    { id: 4226, name: 'Sidi Semiane', nameAr: 'سيدي سميان' },
    { id: 4227, name: 'Sidi-Amar', nameAr: 'سيدي عامر' },
    { id: 4228, name: 'Tipaza', nameAr: 'تيبازة' },
  ],
  43: [
    { id: 4301, name: 'Ahmed Rachedi', nameAr: 'أحمد راشدي' },
    { id: 4302, name: 'Ain Beida Harriche', nameAr: ' عين البيضاء أحريش' },
    { id: 4303, name: 'Ain Mellouk', nameAr: 'عين الملوك' },
    { id: 4304, name: 'Ain Tine', nameAr: 'عين التين' },
    { id: 4305, name: 'Amira Arres', nameAr: 'اعميرة اراس' },
    { id: 4306, name: 'Benyahia Abderrahmane', nameAr: 'بن يحي عبد الرحمن' },
    { id: 4307, name: 'Bouhatem', nameAr: 'بوحاتم' },
    { id: 4308, name: 'Chelghoum Laid', nameAr: 'شلغوم العيد' },
    { id: 4309, name: 'Chigara', nameAr: 'الشيقارة' },
    { id: 4310, name: 'Derrahi Bousselah', nameAr: 'دراحي بوصلاح' },
    { id: 4311, name: 'El Ayadi Barbes', nameAr: 'العياضي برباس' },
    { id: 4312, name: 'El Mechira', nameAr: 'مشيرة' },
    { id: 4313, name: 'Ferdjioua', nameAr: 'فرجيوة' },
    { id: 4314, name: 'Grarem Gouga', nameAr: 'القرارم قوقة' },
    { id: 4315, name: 'Hamala', nameAr: 'حمالة' },
    { id: 4316, name: 'Mila', nameAr: 'ميلة' },
    { id: 4317, name: 'Minar Zarza', nameAr: 'مينار زارزة' },
    { id: 4318, name: 'Oued Athmenia', nameAr: 'وادي العثمانية' },
    { id: 4319, name: 'Oued Endja', nameAr: 'وادي النجاء' },
    { id: 4320, name: 'Oued Seguen', nameAr: 'وادي سقان' },
    { id: 4321, name: 'Ouled Khalouf', nameAr: 'أولاد اخلوف' },
    { id: 4322, name: 'Rouached', nameAr: 'الرواشد' },
    { id: 4323, name: 'Sidi Khelifa', nameAr: 'سيدي خليفة' },
    { id: 4324, name: 'Sidi Merouane', nameAr: 'سيدي مروان' },
    { id: 4325, name: 'Tadjenanet', nameAr: 'تاجنانت' },
    { id: 4326, name: 'Tassadane Haddada', nameAr: 'تسدان حدادة' },
    { id: 4327, name: 'Tassala Lematai', nameAr: 'تسالة لمطاعي' },
    { id: 4328, name: 'Teleghma', nameAr: 'التلاغمة' },
    { id: 4329, name: 'Terrai Bainen', nameAr: 'ترعي باينان' },
    { id: 4330, name: 'Tiberguent', nameAr: 'تيبرقنت' },
    { id: 4331, name: 'Yahia Beniguecha', nameAr: 'يحي بني قشة' },
    { id: 4332, name: 'Zeghaia', nameAr: 'زغاية' },
  ],
  44: [
    { id: 4401, name: 'Ain-Benian', nameAr: 'عين البنيان' },
    { id: 4402, name: 'Ain-Bouyahia', nameAr: 'عين بويحيى' },
    { id: 4403, name: 'Ain-Defla', nameAr: 'عين الدفلى' },
    { id: 4404, name: 'Ain-Lechiakh', nameAr: 'عين الاشياخ' },
    { id: 4405, name: 'Ain-Soltane', nameAr: 'عين السلطان' },
    { id: 4406, name: 'Ain-Torki', nameAr: 'عين التركي' },
    { id: 4407, name: 'Arib', nameAr: 'عريب' },
    { id: 4408, name: 'Bathia', nameAr: 'بطحية' },
    { id: 4409, name: 'Belaas', nameAr: 'بلعاص' },
    { id: 4410, name: 'Ben Allal', nameAr: 'بن علال' },
    { id: 4411, name: 'Bir-Ould-Khelifa', nameAr: 'بئر ولد خليفة' },
    { id: 4412, name: 'Birbouche', nameAr: 'بربوش' },
    { id: 4413, name: 'Bordj-Emir-Khaled', nameAr: 'برج الأمير خالد' },
    { id: 4414, name: 'Boumedfaa', nameAr: 'بومدفع' },
    { id: 4415, name: 'Bourached', nameAr: 'بوراشد' },
    { id: 4416, name: 'Djelida', nameAr: 'جليدة' },
    { id: 4417, name: 'Djemaa Ouled Cheikh', nameAr: 'جمعة أولاد الشيخ' },
    { id: 4418, name: 'Djendel', nameAr: 'جندل' },
    { id: 4419, name: 'El-Abadia', nameAr: 'العبادية' },
    { id: 4420, name: 'El-Amra', nameAr: 'العامرة' },
    { id: 4421, name: 'El-Attaf', nameAr: 'العطاف' },
    { id: 4422, name: 'El-Maine', nameAr: 'الماين' },
    { id: 4423, name: 'Hammam-Righa', nameAr: 'حمام ريغة' },
    { id: 4424, name: 'Hassania', nameAr: 'الحسانية' },
    { id: 4425, name: 'Hoceinia', nameAr: 'الحسينية' },
    { id: 4426, name: 'Khemis-Miliana', nameAr: 'خميس مليانة' },
    { id: 4427, name: 'Mekhatria', nameAr: 'المخاطرية' },
    { id: 4428, name: 'Miliana', nameAr: 'مليانة' },
    { id: 4429, name: 'Oued Chorfa', nameAr: 'وادي الشرفاء' },
    { id: 4430, name: 'Oued Djemaa', nameAr: 'واد الجمعة' },
    { id: 4431, name: 'Rouina', nameAr: 'الروينة' },
    { id: 4432, name: 'Sidi-Lakhdar', nameAr: 'سيدي الأخضر' },
    { id: 4433, name: 'Tacheta Zegagha', nameAr: 'تاشتة زقاغة' },
    { id: 4434, name: 'Tarik-Ibn-Ziad', nameAr: 'طارق بن زياد' },
    { id: 4435, name: 'Tiberkanine', nameAr: 'تبركانين' },
    { id: 4436, name: 'Zeddine', nameAr: 'زدين' },
  ],
  45: [
    { id: 4501, name: 'Ain Ben Khelil', nameAr: 'عين بن خليل' },
    { id: 4502, name: 'Ain Sefra', nameAr: 'عين الصفراء' },
    { id: 4503, name: 'Asla', nameAr: 'عسلة' },
    { id: 4504, name: 'Djenienne Bourezg', nameAr: 'جنين بورزق' },
    { id: 4505, name: 'El Biodh', nameAr: 'البيوض' },
    { id: 4506, name: 'Kasdir', nameAr: 'القصدير' },
    { id: 4507, name: 'Makmen Ben Amar', nameAr: 'مكمن بن عمار' },
    { id: 4508, name: 'Mecheria', nameAr: 'المشرية' },
    { id: 4509, name: 'Moghrar', nameAr: 'مغرار' },
    { id: 4510, name: 'Naama', nameAr: 'النعامة' },
    { id: 4511, name: 'Sfissifa', nameAr: 'سفيسيفة' },
    { id: 4512, name: 'Tiout', nameAr: 'تيوت' },
  ],
  46: [
    { id: 4601, name: 'Aghlal', nameAr: 'أغلال' },
    { id: 4602, name: 'Ain El Arbaa', nameAr: 'عين الأربعاء' },
    { id: 4603, name: 'Ain Kihal', nameAr: 'عين الكيحل' },
    { id: 4604, name: 'Ain Temouchent', nameAr: 'عين تموشنت' },
    { id: 4605, name: 'Ain Tolba', nameAr: 'عين الطلبة' },
    { id: 4606, name: 'Aoubellil', nameAr: 'عقب الليل' },
    { id: 4607, name: 'Beni Saf', nameAr: 'بني صاف' },
    { id: 4608, name: 'Bouzedjar', nameAr: 'بوزجار' },
    { id: 4609, name: 'Chaabat El Ham', nameAr: 'شعبة اللحم' },
    { id: 4610, name: 'Chentouf', nameAr: 'شنتوف' },
    { id: 4611, name: 'El Amria', nameAr: 'العامرية' },
    { id: 4612, name: 'El Maleh', nameAr: 'المالح' },
    { id: 4613, name: 'El Messaid', nameAr: 'المساعيد' },
    { id: 4614, name: 'Emir Abdelkader', nameAr: 'الأمير عبد القادر' },
    { id: 4615, name: 'Hammam Bou Hadjar', nameAr: 'حمام بوحجر' },
    { id: 4616, name: 'Hassasna', nameAr: 'الحساسنة' },
    { id: 4617, name: 'Hassi El Ghella', nameAr: 'حاسي الغلة' },
    { id: 4618, name: 'Oued Berkeche', nameAr: 'وادي برقش' },
    { id: 4619, name: 'Oued Sebbah', nameAr: 'وادي الصباح' },
    { id: 4620, name: 'Ouled Boudjemaa', nameAr: 'أولاد بوجمعة' },
    { id: 4621, name: 'Ouled Kihal', nameAr: 'أولاد الكيحل' },
    { id: 4622, name: 'Oulhaca El Gheraba', nameAr: 'ولهاصة الغرابة' },
    { id: 4623, name: 'Sidi Ben Adda', nameAr: 'سيدي بن عدة' },
    { id: 4624, name: 'Sidi Boumediene', nameAr: 'سيدي بومدين' },
    { id: 4625, name: 'Sidi Ouriache', nameAr: 'سيدي ورياش' },
    { id: 4626, name: 'Sidi Safi', nameAr: 'سيدي صافي' },
    { id: 4627, name: 'Tamzoura', nameAr: 'تامزورة' },
    { id: 4628, name: 'Terga', nameAr: 'تارقة' },
  ],
  47: [
    { id: 4701, name: 'Berriane', nameAr: 'بريان' },
    { id: 4702, name: 'Bounoura', nameAr: 'بونورة' },
    { id: 4703, name: 'Dhayet Bendhahoua', nameAr: 'ضاية بن ضحوة' },
    { id: 4704, name: 'El Atteuf', nameAr: 'العطف' },
    { id: 4705, name: 'El Guerrara', nameAr: 'القرارة' },
    { id: 4706, name: 'Ghardaia', nameAr: 'غرداية' },
    { id: 4707, name: 'Mansoura', nameAr: 'المنصورة' },
    { id: 4708, name: 'Metlili', nameAr: 'متليلي' },
    { id: 4709, name: 'Sebseb', nameAr: 'سبسب' },
    { id: 4710, name: 'Zelfana', nameAr: 'زلفانة' },
  ],
  48: [
    { id: 4801, name: 'Ain Rahma', nameAr: 'عين الرحمة' },
    { id: 4802, name: 'Ain-Tarek', nameAr: 'عين طارق' },
    { id: 4803, name: 'Ammi Moussa', nameAr: 'عمي موسى' },
    { id: 4804, name: 'Belaassel Bouzagza', nameAr: 'بلعسل بوزقزة' },
    { id: 4805, name: 'Bendaoud', nameAr: 'بن داود' },
    { id: 4806, name: 'Beni Dergoun', nameAr: 'بني درقن' },
    { id: 4807, name: 'Beni Zentis', nameAr: 'بني زنطيس' },
    { id: 4808, name: 'Dar Ben Abdelah', nameAr: 'دار بن عبد الله' },
    { id: 4809, name: 'Djidiouia', nameAr: 'جديوية' },
    { id: 4810, name: 'El H\'madna', nameAr: 'الحمادنة' },
    { id: 4811, name: 'El Hassi', nameAr: 'الحاسي' },
    { id: 4812, name: 'El Ouldja', nameAr: 'الولجة' },
    { id: 4813, name: 'El-Guettar', nameAr: 'القطار' },
    { id: 4814, name: 'El-Matmar', nameAr: 'المطمر' },
    { id: 4815, name: 'Had Echkalla', nameAr: 'حد الشكالة' },
    { id: 4816, name: 'Hamri', nameAr: 'حمري' },
    { id: 4817, name: 'Kalaa', nameAr: 'القلعة' },
    { id: 4818, name: 'Lahlef', nameAr: 'لحلاف' },
    { id: 4819, name: 'Mazouna', nameAr: 'مازونة' },
    { id: 4820, name: 'Mediouna', nameAr: 'مديونة' },
    { id: 4821, name: 'Mendes', nameAr: 'منداس' },
    { id: 4822, name: 'Merdja Sidi Abed', nameAr: 'مرجة سيدي عابد' },
    { id: 4823, name: 'Ouarizane', nameAr: 'واريزان' },
    { id: 4824, name: 'Oued El Djemaa', nameAr: 'وادي الجمعة' },
    { id: 4825, name: 'Oued Essalem', nameAr: 'وادي السلام' },
    { id: 4826, name: 'Oued-Rhiou', nameAr: 'وادي رهيو' },
    { id: 4827, name: 'Ouled Aiche', nameAr: 'أولاد يعيش' },
    { id: 4828, name: 'Ouled Sidi Mihoub', nameAr: 'أولاد سيدي الميهوب' },
    { id: 4829, name: 'Ramka', nameAr: 'الرمكة' },
    { id: 4830, name: 'Relizane', nameAr: 'غليزان' },
    { id: 4831, name: 'Sidi Khettab', nameAr: 'سيدي  خطاب' },
    { id: 4832, name: 'Sidi Lazreg', nameAr: 'سيدي لزرق' },
    { id: 4833, name: 'Sidi M\'hamed Benali', nameAr: 'سيدي أمحمد بن علي' },
    { id: 4834, name: 'Sidi M\'hamed Benaouda', nameAr: 'سيدي امحمد بن عودة' },
    { id: 4835, name: 'Sidi Saada', nameAr: 'سيدي سعادة' },
    { id: 4836, name: 'Souk El Had', nameAr: 'سوق الحد' },
    { id: 4837, name: 'Yellel', nameAr: 'يلل' },
    { id: 4838, name: 'Zemmoura', nameAr: 'زمورة' },
  ],
  49: [
    { id: 4901, name: 'Aougrout', nameAr: 'أوقروت' },
    { id: 4902, name: 'Charouine', nameAr: 'شروين' },
    { id: 4903, name: 'Deldoul', nameAr: 'دلدول' },
    { id: 4904, name: 'Ksar Kaddour', nameAr: 'قصر قدور' },
    { id: 4905, name: 'Metarfa', nameAr: 'المطارفة' },
    { id: 4906, name: 'Ouled Aissa', nameAr: 'أولاد عيسى' },
    { id: 4907, name: 'Ouled Said', nameAr: 'أولاد السعيد' },
    { id: 4908, name: 'Talmine', nameAr: 'طالمين' },
    { id: 4909, name: 'Timimoun', nameAr: 'تيميمون' },
    { id: 4910, name: 'Tinerkouk', nameAr: 'تنركوك' },
  ],
  50: [
    { id: 5001, name: 'Bordj Badji Mokhtar', nameAr: 'برج باجي مختار' },
    { id: 5002, name: 'Timiaouine', nameAr: 'تيمياوين' },
  ],
  51: [
    { id: 5101, name: 'Besbes', nameAr: 'بسباس' },
    { id: 5102, name: 'Chaiba', nameAr: 'الشعيبة' },
    { id: 5103, name: 'Doucen', nameAr: 'الدوسن' },
    { id: 5104, name: 'Ouled Djellal', nameAr: 'أولاد جلال' },
    { id: 5105, name: 'Ras El Miad', nameAr: 'رأس الميعاد' },
    { id: 5106, name: 'Sidi Khaled', nameAr: 'سيدي  خالد' },
  ],
  52: [
    { id: 5201, name: 'Beni-Abbes', nameAr: 'بني عباس' },
    { id: 5202, name: 'Beni-Ikhlef', nameAr: 'بن يخلف' },
    { id: 5203, name: 'El Ouata', nameAr: 'الواتة' },
    { id: 5204, name: 'Igli', nameAr: 'إقلي' },
    { id: 5205, name: 'Kerzaz', nameAr: 'كرزاز' },
    { id: 5206, name: 'Ksabi', nameAr: 'القصابي' },
    { id: 5207, name: 'Ouled-Khodeir', nameAr: 'أولاد خضير' },
    { id: 5208, name: 'Tamtert', nameAr: 'تامترت' },
    { id: 5209, name: 'Timoudi', nameAr: 'تيمودي' },
  ],
  53: [
    { id: 5301, name: 'Ain Salah', nameAr: 'عين صالح' },
    { id: 5302, name: 'Foggaret Ezzoua', nameAr: 'فقارة الزوى' },
    { id: 5303, name: 'Inghar', nameAr: 'إينغر' },
  ],
  54: [
    { id: 5401, name: 'Ain Guezzam', nameAr: 'عين قزام' },
    { id: 5402, name: 'Tin Zouatine', nameAr: 'تين زواتين' },
  ],
  55: [
    { id: 5501, name: 'Benaceur', nameAr: 'بن ناصر' },
    { id: 5502, name: 'Blidet Amor', nameAr: 'بلدة اعمر' },
    { id: 5503, name: 'El Alia', nameAr: 'العالية' },
    { id: 5504, name: 'El-Hadjira', nameAr: 'الحجيرة' },
    { id: 5505, name: 'M\'naguer', nameAr: 'المنقر' },
    { id: 5506, name: 'Megarine', nameAr: 'المقارين' },
    { id: 5507, name: 'Nezla', nameAr: 'النزلة' },
    { id: 5508, name: 'Sidi Slimane', nameAr: 'سيدي سليمان' },
    { id: 5509, name: 'Taibet', nameAr: 'الطيبات' },
    { id: 5510, name: 'Tebesbest', nameAr: 'تبسبست' },
    { id: 5511, name: 'Temacine', nameAr: 'تماسين' },
    { id: 5512, name: 'Touggourt', nameAr: 'تقرت' },
    { id: 5513, name: 'Zaouia El Abidia', nameAr: 'الزاوية العابدية' },
  ],
  56: [
    { id: 5601, name: 'Bordj El Haouass', nameAr: 'برج الحواس' },
    { id: 5602, name: 'Djanet', nameAr: 'جانت' },
  ],
  57: [
    { id: 5701, name: 'Djamaa', nameAr: 'جامعة' },
    { id: 5702, name: 'El-M\'ghaier', nameAr: 'المغير' },
    { id: 5703, name: 'M\'rara', nameAr: 'المرارة' },
    { id: 5704, name: 'Oum Touyour', nameAr: 'أم الطيور' },
    { id: 5705, name: 'Sidi Amrane', nameAr: 'سيدي عمران' },
    { id: 5706, name: 'Sidi Khelil', nameAr: 'سيدي خليل' },
    { id: 5707, name: 'Still', nameAr: 'سطيل' },
    { id: 5708, name: 'Tenedla', nameAr: 'تندلة' },
  ],
  58: [
    { id: 5801, name: 'El Meniaa', nameAr: 'المنيعة' },
    { id: 5802, name: 'Hassi Fehal', nameAr: 'حاسي الفحل' },
    { id: 5803, name: 'Hassi Gara', nameAr: 'حاسي القارة' },
  ],
};

export function getCommunesByWilaya(wilayaId: number): Commune[] {
  return COMMUNES[wilayaId] || [];
}

export function getCommuneById(wilayaId: number, communeId: number): Commune | undefined {
  return COMMUNES[wilayaId]?.find(c => c.id === communeId);
}
